var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path, _g10, _g11, _g12, _g13, _path2, _g14, _g15, _path3, _g16, _g17, _g18, _g19, _g20, _g21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeveloper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 796.583,
    height: 953.587,
    viewBox: "0 0 796.583 953.587",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3508",
    "data-name": "Rectangle 3508",
    width: 61.038,
    height: 52.441,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3540",
    "data-name": "Rectangle 3540",
    width: 211.961,
    height: 261.982,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3509",
    "data-name": "Rectangle 3509",
    width: 42.187,
    height: 15.412,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3510",
    "data-name": "Rectangle 3510",
    width: 53.601,
    height: 18.717,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3511",
    "data-name": "Rectangle 3511",
    width: 30.509,
    height: 73.036,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3512",
    "data-name": "Rectangle 3512",
    width: 43.699,
    height: 77.828,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3513",
    "data-name": "Rectangle 3513",
    width: 40.742,
    height: 30.56,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3514",
    "data-name": "Rectangle 3514",
    width: 41.255,
    height: 45.228,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3515",
    "data-name": "Rectangle 3515",
    width: 103.657,
    height: 74.985,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3516",
    "data-name": "Rectangle 3516",
    width: 89.59,
    height: 38.26,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3517",
    "data-name": "Rectangle 3517",
    width: 39.291,
    height: 10.891,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3518",
    "data-name": "Rectangle 3518",
    width: 60.874,
    height: 87.921,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3519",
    "data-name": "Rectangle 3519",
    width: 25.678,
    height: 25.084,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3520",
    "data-name": "Rectangle 3520",
    width: 40.317,
    height: 11.73,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3521",
    "data-name": "Rectangle 3521",
    width: 33.869,
    height: 20.005,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3522",
    "data-name": "Rectangle 3522",
    width: 56.204,
    height: 28.837,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3523",
    "data-name": "Rectangle 3523",
    width: 51.721,
    height: 48.351,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3525",
    "data-name": "Rectangle 3525",
    width: 35.893,
    height: 87.463,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3526",
    "data-name": "Rectangle 3526",
    width: 35.591,
    height: 87.403,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3527",
    "data-name": "Rectangle 3527",
    width: 83.783,
    height: 25.312,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3528",
    "data-name": "Rectangle 3528",
    width: 64.721,
    height: 29.142,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3529",
    "data-name": "Rectangle 3529",
    width: 2.855,
    height: 7.771,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3530",
    "data-name": "Rectangle 3530",
    width: 0.039,
    height: 0.318,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3532",
    "data-name": "Rectangle 3532",
    width: 23.284,
    height: 26.282,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3533",
    "data-name": "Rectangle 3533",
    width: 23.284,
    height: 16.292,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3534",
    "data-name": "Rectangle 3534",
    width: 79.747,
    height: 20.157,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3535",
    "data-name": "Rectangle 3535",
    width: 78.718,
    height: 21.056,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3536",
    "data-name": "Rectangle 3536",
    width: 13.464,
    height: 4.303,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3537",
    "data-name": "Rectangle 3537",
    width: 62.487,
    height: 87.291,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3538",
    "data-name": "Rectangle 3538",
    width: 42.222,
    height: 12.399,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3547",
    "data-name": "Rectangle 3547",
    width: 141,
    height: 147,
    transform: "translate(-0.455 0.159)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3508-2",
    "data-name": "Rectangle 3508",
    width: 29.1,
    height: 24.512,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4cb8b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099d6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_52270",
    x: 0,
    y: 0,
    width: 421.24,
    height: 413.933,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 38,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_31154",
    "data-name": "Group 31154",
    transform: "translate(-624.5 -49.033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30412",
    "data-name": "Group 30412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26401",
    "data-name": "Group 26401",
    transform: "translate(725.543 160.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26402",
    "data-name": "Group 26402",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26398",
    "data-name": "Group 26398"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25828",
    "data-name": "Group 25828",
    transform: "translate(22.779 769.824)",
    opacity: 0.187
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25827",
    "data-name": "Group 25827",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52089",
    "data-name": "Path 52089",
    d: "M730.531,455.792c0,11.03-132.4,19.971-295.71,19.971S139.11,466.822,139.11,455.792,271.5,435.821,434.821,435.821,730.531,444.762,730.531,455.792Z",
    transform: "translate(-139.11 -435.821)",
    fill: "#070e1c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25847",
    "data-name": "Group 25847",
    transform: "translate(143.89 684.456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25837",
    "data-name": "Group 25837",
    transform: "translate(278.246)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25832",
    "data-name": "Group 25832",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25831",
    "data-name": "Group 25831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25830",
    "data-name": "Group 25830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25829",
    "data-name": "Group 25829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52090",
    "data-name": "Path 52090",
    d: "M316.621,414.766v90.42h37.52l21.442-76.864,7.941-28.474Z",
    transform: "translate(-316.621 -399.848)",
    fill: "#5c5c5c"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25836",
    "data-name": "Group 25836",
    transform: "translate(0 0)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25835",
    "data-name": "Group 25835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25834",
    "data-name": "Group 25834"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25833",
    "data-name": "Group 25833"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52091",
    "data-name": "Path 52091",
    d: "M316.621,414.766v23.076c17.015-1.892,41.276-6.191,58.964-9.521l7.939-28.473Z",
    transform: "translate(-316.621 -399.848)",
    fill: "#5c5c5c"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25846",
    "data-name": "Group 25846"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25841",
    "data-name": "Group 25841",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25840",
    "data-name": "Group 25840"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25839",
    "data-name": "Group 25839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25838",
    "data-name": "Group 25838"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52092",
    "data-name": "Path 52092",
    d: "M259.847,414.766v90.42h-37.52l-21.442-76.864-7.941-28.474Z",
    transform: "translate(-192.943 -399.848)",
    fill: "#5c5c5c"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25845",
    "data-name": "Group 25845",
    transform: "translate(0 0)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25844",
    "data-name": "Group 25844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25843",
    "data-name": "Group 25843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25842",
    "data-name": "Group 25842"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52093",
    "data-name": "Path 52093",
    d: "M259.846,414.766v23.076c-17.015-1.892-41.276-6.191-58.962-9.521l-7.942-28.473Z",
    transform: "translate(-192.943 -399.848)",
    fill: "#5c5c5c"
  })))))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25859",
    "data-name": "Group 25859",
    transform: "translate(66.637 90.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25851",
    "data-name": "Group 25851",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25850",
    "data-name": "Group 25850"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25849",
    "data-name": "Group 25849"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25848",
    "data-name": "Group 25848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52094",
    "data-name": "Path 52094",
    d: "M161.454,235.693c3.323,34.874,32.6,161.859,47.346,224.447,1.469,6.245,2.792,11.843,3.937,16.651,2.781,11.728,4.463,18.711,4.463,18.711l315.56-6.621s.882-4.04,2.407-11.19c11.282-52.824,57.839-275.582,45.544-297.288a18.375,18.375,0,0,0-3.8-4.513,35.809,35.809,0,0,0-4.07-3.109,58.805,58.805,0,0,0-5.136-3.019c-22.835-12.063-70.456-22.1-124.536-28.028-63.772-7.006-136.518-8.279-188.147-.394-1.474.225-2.934.459-4.369.7q-5.642.928-10.835,1.917c-67.679,12.819-80.784,31.24-81.205,57.331v.022C158.455,211.56,160.243,222.968,161.454,235.693Z",
    transform: "translate(-158.605 -135.936)",
    fill: "#f45642"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25858",
    "data-name": "Group 25858",
    transform: "translate(0.01 8.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25857",
    "data-name": "Group 25857"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25856",
    "data-name": "Group 25856"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25855",
    "data-name": "Group 25855"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52096",
    "data-name": "Path 52096",
    d: "M158.609,196.834v.022c.135,9.55,1.728,20.1,2.839,31.746,3.323,34.874,32.6,161.861,47.344,224.45h51.567s-56.863-207.39-60.208-258.4c-2.185-33.294,22.351-48.566,39.663-55.151C172.135,152.32,159.028,170.741,158.609,196.834Z",
    transform: "translate(-158.609 -139.503)",
    fill: "#e84430"
  }))))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25882",
    "data-name": "Group 25882",
    transform: "translate(441.954 339.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25863",
    "data-name": "Group 25863",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25862",
    "data-name": "Group 25862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25861",
    "data-name": "Group 25861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25860",
    "data-name": "Group 25860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52097",
    "data-name": "Path 52097",
    d: "M326.494,343.677s53.079-5.15,57.427,14.061c3.391,14.986-1.154,149.184-3.316,207.5A28.078,28.078,0,0,0,407.1,594.309c3.377.191,6.936.36,10.6.49,17.584.628,37.53.378,51.2-2.709,29.776-6.722,30.736-48.98,41.3-119.1s20.171-194.973-45.139-218.985c-2.247-.826-4.5-1.575-6.742-2.254C395.384,232.73,335.4,270.337,335.4,270.337,320.892,310.468,326.494,343.677,326.494,343.677Z",
    transform: "translate(-325.43 -246.381)",
    fill: "#de3e2b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25868",
    "data-name": "Group 25868",
    transform: "translate(92.262 5.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25867",
    "data-name": "Group 25867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25866",
    "data-name": "Group 25866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25865",
    "data-name": "Group 25865"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25864",
    "data-name": "Group 25864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52098",
    "data-name": "Path 52098",
    d: "M366.44,591.815c17.584.628,37.53.378,51.2-2.709,29.776-6.722,30.736-48.98,41.3-119.1s20.171-194.973-45.139-218.985c-2.247-.826-4.5-1.575-6.742-2.254-11.129,2.657-21.355,10.041-26.876,26.266C365.225,319.04,388.98,471.95,366.44,591.815Z",
    transform: "translate(-366.44 -248.769)",
    fill: "#f45642"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25881",
    "data-name": "Group 25881",
    transform: "translate(112.564 20.735)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25880",
    "data-name": "Group 25880"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25879",
    "data-name": "Group 25879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25878",
    "data-name": "Group 25878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52101",
    "data-name": "Path 52101",
    d: "M426.774,284.09a1.324,1.324,0,0,0,.295-.031,1.356,1.356,0,0,0,1.03-1.617c-.2-.893-5.048-21.929-22.574-26.115-7.1-1.7-13.409-.423-18.747,3.789-7.717,6.092-11.314,17.1-11.314,22.621a1.357,1.357,0,0,0,2.713,0c0-4.317,3.017-14.758,10.281-20.493,4.652-3.669,10.182-4.774,16.437-3.278,15.892,3.8,20.511,23.861,20.556,24.064A1.355,1.355,0,0,0,426.774,284.09Z",
    transform: "translate(-375.464 -255.597)",
    fill: "#d63925"
  }))))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25886",
    "data-name": "Group 25886",
    transform: "translate(73.801 421.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25885",
    "data-name": "Group 25885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25884",
    "data-name": "Group 25884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25883",
    "data-name": "Group 25883"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52102",
    "data-name": "Path 52102",
    d: "M161.789,289.139c3.384,14.261,5.431,22.756,5.431,22.756l383.815-8.056s1.071-4.909,2.923-13.609C485.936,278.669,252.522,282.574,161.789,289.139Z",
    transform: "translate(-161.789 -282.847)",
    fill: "#bf632d"
  })))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25899",
    "data-name": "Group 25899",
    transform: "translate(76.732 430.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25890",
    "data-name": "Group 25890",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25889",
    "data-name": "Group 25889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25888",
    "data-name": "Group 25888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25887",
    "data-name": "Group 25887"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52103",
    "data-name": "Path 52103",
    d: "M163.221,356.676c.1,7.235.252,14.9.493,22.846,2.137,71.536,10.891,165.841,41.915,174.107C256.14,567.1,569.561,573.947,585.939,544c4.889-8.938,7.932-23.985,9.914-42.4.387-3.606.731-7.343,1.042-11.188,2.693-33.323,2.72-74.782,3.834-110.893.3-9.7.68-19.028,1.21-27.694,3.885-63.655-47.92-64.557-47.92-64.557-73.245-1.714-180.852,1.716-264.543,5.249-43.641,1.845-80.778,3.71-103.158,4.889-14.4.76-22.684,1.235-22.684,1.235S162.773,323,163.221,356.676Z",
    transform: "translate(-163.092 -286.816)",
    fill: "#e24b38"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25894",
    "data-name": "Group 25894",
    transform: "translate(106.552 187.246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25893",
    "data-name": "Group 25893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25892",
    "data-name": "Group 25892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25891",
    "data-name": "Group 25891"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52104",
    "data-name": "Path 52104",
    d: "M349.49,398.523q9.479,0,19.557-.2C470.2,396.262,528.425,373.492,529,373.262a1.668,1.668,0,0,0-1.235-3.1c-.571.227-58.3,22.777-158.79,24.824-100.62,2.041-155.884-12.272-156.43-12.417a1.668,1.668,0,0,0-.855,3.224C212.208,385.931,260.8,398.523,349.49,398.523Z",
    transform: "translate(-210.453 -370.045)",
    fill: "#d63925"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25898",
    "data-name": "Group 25898",
    transform: "translate(0.129 5.704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25897",
    "data-name": "Group 25897"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25896",
    "data-name": "Group 25896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25895",
    "data-name": "Group 25895"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52105",
    "data-name": "Path 52105",
    d: "M163.149,353.507c.1,7.235.252,14.9.493,22.846,2.137,71.536,10.891,165.841,41.915,174.107,50.512,13.467,363.932,20.317,380.31-9.629,4.888-8.938,7.932-23.985,9.915-42.4.387-3.606.731-7.343,1.042-11.188-14.862,9.913-59.486,22.914-90.148,26.059-127.829,13.109-227.3-4.747-227.3-4.747,16.783-69.2,12.329-179.7,10.025-219.208-43.641,1.845-80.778,3.71-103.158,4.889Z",
    transform: "translate(-163.149 -289.351)",
    fill: "#de3e2b"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_141910",
    "data-name": "Path 141910",
    d: "M-20356.2-1655.154s36.441-23.453,108.477-51.586,76.625-42.479,137.172-9.8,114.6,37.755,114.6,37.755l10.688-43.8v-179.26s-217.242,53.823-221.332,52.888-93.129-27.224-93.129-27.224l-34.174,3.359h-13.686s.6,100.049,0,106.3S-20356.2-1655.154-20356.2-1655.154Z",
    transform: "translate(20454.725 1863.059)",
    fill: "#c13120"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26330",
    "data-name": "Group 26330",
    transform: "translate(138.086 0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_141912",
    "data-name": "Path 141912",
    d: "M-20210.377-2155c-75.945,18.648-90.8,26.261-132.832,81.9s-39.457,114.911-39.457,114.911l30.07,16.24,81.867,15.57s42.375-96.221,42.846-100.148S-20210.377-2155-20210.377-2155Z",
    transform: "translate(20393.371 2293.22)",
    fill: "#c13120"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_26148",
    "data-name": "Group 26148",
    transform: "translate(106.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25957",
    "data-name": "Group 25957",
    transform: "translate(0 132.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25909",
    "data-name": "Group 25909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25908",
    "data-name": "Group 25908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25907",
    "data-name": "Group 25907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25906",
    "data-name": "Group 25906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25905",
    "data-name": "Group 25905"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25904",
    "data-name": "Group 25904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25903",
    "data-name": "Group 25903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25902",
    "data-name": "Group 25902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25901",
    "data-name": "Group 25901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25900",
    "data-name": "Group 25900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52106",
    "data-name": "Path 52106",
    d: "M446.133,468.16a97.835,97.835,0,0,1-12.583,9.523c-.144.1-.3.187-.439.274-3.249,2.077-6.707,4.05-10.335,5.908-1.3.664-2.621,1.314-3.951,1.944A175.461,175.461,0,0,1,383.5,497.931c-1.163.284-2.335.543-3.517.785-3.406.734-6.862,1.388-10.367,1.939-1.172.2-2.351.371-3.532.542a208.435,208.435,0,0,1-41.978,1.732q-2.521-.148-5.04-.371-6.709-.557-13.413-1.615c-.11-.013-.211-.036-.322-.047q-2.018-.321-4.036-.686a179.107,179.107,0,0,1-21.463-5.244,159.089,159.089,0,0,1-18.144-6.846c-1.01-.439-2.009-.911-3.008-1.37-1.247-.6-2.486-1.2-3.712-1.829-.11-.052-.229-.106-.349-.166-7.012-20.264-13.843-92.267-15.625-113.786-.369-4.286-.634-8.569-.85-12.853-.464-9.694-.563-19.4-.4-29.236.023-1.289.045-2.567.088-3.867.013-.713.027-1.438.049-2.162.252-9.139.718-18.383,1.318-27.818.07-1.177.153-2.353.223-3.539q.591-8.585,1.276-17.377c.976-12.448,2.079-25.267,3.152-38.619,1.739-21.487,6.61-38.347,14.441-49.677a44.009,44.009,0,0,1,6.477-7.5,33.584,33.584,0,0,1,18.289-8.668,97.508,97.508,0,0,0,11.773-2.38c.666-.169,1.3-.349,1.942-.54,2.016-.578,3.908-1.208,5.683-1.852,2.047-.749,3.933-1.532,5.649-2.306.272-.117.546-.243.81-.358.459-.225.916-.427,1.352-.65a70.614,70.614,0,0,0,11.53-6.855l50.359.893c.382.58.776,1.141,1.168,1.681.04.04.061.081.09.112a37.671,37.671,0,0,0,11.7,10.245c.817.479,1.656.916,2.484,1.334.639.333,1.3.637,1.957.94.679.3,1.368.6,2.058.882,1.64.675,3.292,1.278,4.952,1.849a.564.564,0,0,0,.061.011c12.131,4.113,24.5,6,31.146,15.132a22.865,22.865,0,0,1,2.617,4.709,29.149,29.149,0,0,1,1.687,5.91,24.171,24.171,0,0,1,.362,4.025c.241,14.774-8.745,42.3-8.668,93.678q0,4.806.126,9.861c.023,1.008.045,2.025.079,3.042.052,2.086.137,4.2.23,6.358v.011c.1,2.155.2,4.353.335,6.58.229,4.153.524,8.448.891,12.844q.455,5.791,1.1,11.89.645,6.236,1.456,12.8c2.177,17.418,7.132,52,12.488,81.077.835,4.576,1.692,9.01,2.545,13.224.092.445.176.88.268,1.314C444.236,459.809,445.185,464.2,446.133,468.16Z",
    transform: "translate(-237.672 -154.714)",
    fill: "#4cb8b6"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25947",
    "data-name": "Group 25947",
    transform: "translate(34.196 186.81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25946",
    "data-name": "Group 25946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25945",
    "data-name": "Group 25945"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25944",
    "data-name": "Group 25944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25943",
    "data-name": "Group 25943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25942",
    "data-name": "Group 25942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25941",
    "data-name": "Group 25941"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25940",
    "data-name": "Group 25940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25939",
    "data-name": "Group 25939"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52111",
    "data-name": "Path 52111",
    d: "M336.395,281.576a79.461,79.461,0,0,1-13.6-1.447c-11.364-2.182-23.2-6.81-35.175-13.755a169.951,169.951,0,0,1-34.419-26.59,1.258,1.258,0,0,1-.018-1.676,1.03,1.03,0,0,1,1.543-.022A167.754,167.754,0,0,0,288.7,264.309c18.453,10.693,46.2,21.15,73.623,10.257a1.069,1.069,0,0,1,1.4.706,1.22,1.22,0,0,1-.655,1.521A68.407,68.407,0,0,1,336.395,281.576Z",
    transform: "translate(-252.872 -237.749)",
    fill: "#0f1b30",
    opacity: 0.1
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25956",
    "data-name": "Group 25956",
    transform: "translate(44.745 157.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25955",
    "data-name": "Group 25955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25954",
    "data-name": "Group 25954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25953",
    "data-name": "Group 25953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25952",
    "data-name": "Group 25952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25951",
    "data-name": "Group 25951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25950",
    "data-name": "Group 25950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25949",
    "data-name": "Group 25949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25948",
    "data-name": "Group 25948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52112",
    "data-name": "Path 52112",
    d: "M348.609,248.672a79.569,79.569,0,0,1-13.573,1.674c-11.564.45-24.14-1.375-37.38-5.424a170.013,170.013,0,0,1-39.548-18.1,1.258,1.258,0,0,1-.4-1.629,1.032,1.032,0,0,1,1.5-.371,167.7,167.7,0,0,0,39.033,17.841c20.394,6.232,49.792,10.128,74.03-6.693a1.068,1.068,0,0,1,1.523.369,1.221,1.221,0,0,1-.292,1.631A68.386,68.386,0,0,1,348.609,248.672Z",
    transform: "translate(-257.561 -224.64)",
    fill: "#0f1b30",
    opacity: 0.1
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26147",
    "data-name": "Group 26147",
    transform: "translate(76.557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26146",
    "data-name": "Group 26146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25974",
    "data-name": "Group 25974",
    transform: "translate(6.619 92.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25973",
    "data-name": "Group 25973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25972",
    "data-name": "Group 25972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25963",
    "data-name": "Group 25963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25962",
    "data-name": "Group 25962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25961",
    "data-name": "Group 25961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25960",
    "data-name": "Group 25960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25959",
    "data-name": "Group 25959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25958",
    "data-name": "Group 25958"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52113",
    "data-name": "Path 52113",
    d: "M328.477,177.471l-2.146,12.992a41.1,41.1,0,0,1-5.148,2.466c-24.88,9.834-46.541-10.945-46.541-10.945l7.435-45.047,40.865,35.7Z",
    transform: "translate(-274.643 -136.937)",
    fill: "#ffae95"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25971",
    "data-name": "Group 25971",
    transform: "translate(17.809 22.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25970",
    "data-name": "Group 25970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25969",
    "data-name": "Group 25969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25968",
    "data-name": "Group 25968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25967",
    "data-name": "Group 25967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25966",
    "data-name": "Group 25966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25965",
    "data-name": "Group 25965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25964",
    "data-name": "Group 25964"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52114",
    "data-name": "Path 52114",
    d: "M318.585,164.823l-2.146,12.992a41.081,41.081,0,0,1-5.147,2.466c-18.025-10.767-28.732-33.224-28.732-33.224l30.491,12.934Z",
    transform: "translate(-282.559 -147.057)",
    fill: "#341a1b"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26145",
    "data-name": "Group 26145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25982",
    "data-name": "Group 25982",
    transform: "translate(84.581 26.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25981",
    "data-name": "Group 25981"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25980",
    "data-name": "Group 25980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25979",
    "data-name": "Group 25979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25978",
    "data-name": "Group 25978"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25977",
    "data-name": "Group 25977"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25976",
    "data-name": "Group 25976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25975",
    "data-name": "Group 25975"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52115",
    "data-name": "Path 52115",
    d: "M309.525,107.545s24.223,10.5,11.517,29.53C321.041,137.075,307.381,116.009,309.525,107.545Z",
    transform: "translate(-309.296 -107.545)",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25990",
    "data-name": "Group 25990",
    transform: "translate(83.666 75.763)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25989",
    "data-name": "Group 25989"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25988",
    "data-name": "Group 25988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25987",
    "data-name": "Group 25987"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25986",
    "data-name": "Group 25986"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25985",
    "data-name": "Group 25985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25984",
    "data-name": "Group 25984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25983",
    "data-name": "Group 25983"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52116",
    "data-name": "Path 52116",
    d: "M311.477,132.124s8.846-7.5,11.593,1.9-3.386,26.522-14.18,21.784Z",
    transform: "translate(-308.89 -129.289)",
    fill: "#ffae95"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25998",
    "data-name": "Group 25998",
    transform: "translate(12.574 21.319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25997",
    "data-name": "Group 25997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25996",
    "data-name": "Group 25996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25995",
    "data-name": "Group 25995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25994",
    "data-name": "Group 25994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25993",
    "data-name": "Group 25993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25992",
    "data-name": "Group 25992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25991",
    "data-name": "Group 25991"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52117",
    "data-name": "Path 52117",
    d: "M353.825,194.238s-4.4,26.867-32.43,22.205c-27.863-4.623-43.256-29.546-44.077-30.718l-.027-.031.628-5.694,3.253-29.562,1.737-15.8s1.1-28.783,28.846-29.515c20.275-.533,38.169,5.741,45.783,17.483a24.3,24.3,0,0,1,3.822,15.157l-3.773,28.277-.925,6.927Z",
    transform: "translate(-277.29 -105.089)",
    fill: "#ffae95"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26006",
    "data-name": "Group 26006",
    transform: "translate(8.461 21.319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26005",
    "data-name": "Group 26005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26004",
    "data-name": "Group 26004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26003",
    "data-name": "Group 26003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26002",
    "data-name": "Group 26002"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26001",
    "data-name": "Group 26001"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26000",
    "data-name": "Group 26000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25999",
    "data-name": "Group 25999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52118",
    "data-name": "Path 52118",
    d: "M275.516,135.6c-.014.232-.025.454-.032.679a24.834,24.834,0,0,0,.135,3.912,23.8,23.8,0,0,0,2.1,7.244c7.669,3.026,10.574,7.946,11.415,12.241l6.85,2.065s2.8-11.229,1.831-20.255c-.569-5.325,3.163-7.177,6.027-10.268l0-.007a11.441,11.441,0,0,0,2.223-3.3,7.469,7.469,0,0,0,.844-5.1s11.258-6.009,22.583-.382,22.043,8.7,28.7,2.371a6.173,6.173,0,0,0,1.629-2.2c-7.616-11.739-25.506-18.018-45.783-17.481-27.749.729-36,12.725-36,12.725C274.868,124.127,275.892,129.812,275.516,135.6Z",
    transform: "translate(-275.462 -105.089)",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26008",
    "data-name": "Group 26008",
    transform: "translate(8.619 47.45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26007",
    "data-name": "Group 26007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52119",
    "data-name": "Path 52119",
    d: "M275.532,125.676a23.809,23.809,0,0,0,2.1,7.244c7.669,3.026,10.574,7.946,11.415,12.241l6.851,2.065s2.8-11.229,1.831-20.255c-.569-5.325,3.163-7.177,6.027-10.268C297.793,117.116,285.039,122.283,275.532,125.676Z",
    transform: "translate(-275.532 -116.704)",
    fill: "#341a1b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26045",
    "data-name": "Group 26045",
    transform: "translate(5.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26010",
    "data-name": "Group 26010",
    transform: "translate(1.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26009",
    "data-name": "Group 26009"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52120",
    "data-name": "Path 52120",
    d: "M274.785,128.372s46.52-10.045,77.745-6c.814.108,1.622.22,2.416.351a58.208,58.208,0,0,1,9,2.095s-3.312-16.792-23.782-24.923a55.831,55.831,0,0,0-7.681-2.409,71.766,71.766,0,0,0-12.367-1.75c-.148-.011-.3-.022-.45-.029q-1.8-.1-3.5-.092a55.522,55.522,0,0,0-9.71.79q-1.168.2-2.279.448a41.026,41.026,0,0,0-13.94,5.845,37.921,37.921,0,0,0-3.476,2.61A34.024,34.024,0,0,0,274.785,128.372Z",
    transform: "translate(-274.785 -95.613)",
    fill: "#f45642"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26017",
    "data-name": "Group 26017",
    transform: "translate(59.087 1.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26016",
    "data-name": "Group 26016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26015",
    "data-name": "Group 26015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26014",
    "data-name": "Group 26014"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26013",
    "data-name": "Group 26013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26012",
    "data-name": "Group 26012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26011",
    "data-name": "Group 26011"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52121",
    "data-name": "Path 52121",
    d: "M300.43,96.445a41,41,0,0,1,20.05,24.887q.317,1.134.576,2.328l2.2-.47c-.113-.508-.229-1.015-.358-1.507a42.18,42.18,0,0,0-14.786-22.828A55.826,55.826,0,0,0,300.43,96.445Z",
    transform: "translate(-300.43 -96.445)",
    fill: "#db321c"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26024",
    "data-name": "Group 26024",
    transform: "translate(42.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26023",
    "data-name": "Group 26023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26022",
    "data-name": "Group 26022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26021",
    "data-name": "Group 26021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26020",
    "data-name": "Group 26020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26019",
    "data-name": "Group 26019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26018",
    "data-name": "Group 26018"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52122",
    "data-name": "Path 52122",
    d: "M293.178,95.613c10.059,6.509,13.255,19.8,13.294,19.951l2.189-.5c-.139-.612-2.9-12.063-11.534-19.325-.149-.011-.3-.022-.45-.029Q294.881,95.608,293.178,95.613Z",
    transform: "translate(-293.178 -95.613)",
    fill: "#db321c"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26031",
    "data-name": "Group 26031",
    transform: "translate(30.769 0.79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26030",
    "data-name": "Group 26030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26029",
    "data-name": "Group 26029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26028",
    "data-name": "Group 26028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26027",
    "data-name": "Group 26027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26026",
    "data-name": "Group 26026"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26025",
    "data-name": "Group 26025"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52123",
    "data-name": "Path 52123",
    d: "M287.856,96.412c-.139,5.622.688,17.418,9.109,24.763l1.48-1.681c-7.908-6.9-8.473-18.515-8.311-23.53C289.357,96.1,288.6,96.247,287.856,96.412Z",
    transform: "translate(-287.843 -95.964)",
    fill: "#db321c"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26038",
    "data-name": "Group 26038",
    transform: "translate(11.003 7.083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26037",
    "data-name": "Group 26037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26036",
    "data-name": "Group 26036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26035",
    "data-name": "Group 26035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26034",
    "data-name": "Group 26034"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26033",
    "data-name": "Group 26033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26032",
    "data-name": "Group 26032"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52124",
    "data-name": "Path 52124",
    d: "M280.515,122.21l2.1-.8c-2.923-7.582-.326-16.567,2.281-22.651a37.909,37.909,0,0,0-3.476,2.61C279.273,107.488,277.838,115.27,280.515,122.21Z",
    transform: "translate(-279.057 -98.761)",
    fill: "#db321c"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26044",
    "data-name": "Group 26044",
    transform: "translate(0 17.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26043",
    "data-name": "Group 26043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26042",
    "data-name": "Group 26042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26041",
    "data-name": "Group 26041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26040",
    "data-name": "Group 26040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26039",
    "data-name": "Group 26039"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52125",
    "data-name": "Path 52125",
    d: "M366.444,123.8s-43.506-16.043-89.2,9.141a14.062,14.062,0,0,1-1.6-15.008s44.379-28.268,89.491-5.582A10.852,10.852,0,0,1,366.444,123.8Z",
    transform: "translate(-274.166 -103.539)",
    fill: "#db321c"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26054",
    "data-name": "Group 26054",
    transform: "translate(37.639 74.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26053",
    "data-name": "Group 26053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26052",
    "data-name": "Group 26052"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26051",
    "data-name": "Group 26051"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26050",
    "data-name": "Group 26050"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26049",
    "data-name": "Group 26049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26048",
    "data-name": "Group 26048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26047",
    "data-name": "Group 26047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26046",
    "data-name": "Group 26046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52126",
    "data-name": "Path 52126",
    d: "M306.512,134.006c-.322,1.955-4.628,2.877-9.613,2.059s-8.77-3.066-8.448-5.022,4.628-2.88,9.616-2.061S306.836,132.048,306.512,134.006Z",
    transform: "translate(-288.432 -128.683)",
    fill: "#ffae95"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26063",
    "data-name": "Group 26063",
    transform: "translate(81.291 81.56)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26062",
    "data-name": "Group 26062"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26061",
    "data-name": "Group 26061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26060",
    "data-name": "Group 26060"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26059",
    "data-name": "Group 26059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26058",
    "data-name": "Group 26058"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26057",
    "data-name": "Group 26057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26056",
    "data-name": "Group 26056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26055",
    "data-name": "Group 26055"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52127",
    "data-name": "Path 52127",
    d: "M318.488,139.5c-.709-.045-1.444-.128-2.193-.252-4.983-.817-8.765-3.069-8.441-5.024s4.628-2.88,9.611-2.061q1.012.165,1.948.409Z",
    transform: "translate(-307.834 -131.865)",
    fill: "#ffae95"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26104",
    "data-name": "Group 26104",
    transform: "translate(44.262 50.356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26071",
    "data-name": "Group 26071",
    transform: "translate(7.997 16.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26070",
    "data-name": "Group 26070"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26069",
    "data-name": "Group 26069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26068",
    "data-name": "Group 26068"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26067",
    "data-name": "Group 26067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26066",
    "data-name": "Group 26066"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26065",
    "data-name": "Group 26065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26064",
    "data-name": "Group 26064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52128",
    "data-name": "Path 52128",
    d: "M301.088,129.346c-.443,2.686-2.025,4.661-3.534,4.414s-2.371-2.625-1.928-5.312,2.027-4.662,3.534-4.414S301.531,126.66,301.088,129.346Z",
    transform: "translate(-295.509 -124.014)",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26079",
    "data-name": "Group 26079",
    transform: "translate(34.672 20.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26078",
    "data-name": "Group 26078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26077",
    "data-name": "Group 26077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26076",
    "data-name": "Group 26076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26075",
    "data-name": "Group 26075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26074",
    "data-name": "Group 26074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26073",
    "data-name": "Group 26073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26072",
    "data-name": "Group 26072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52129",
    "data-name": "Path 52129",
    d: "M312.945,131.291c-.443,2.686-2.027,4.662-3.535,4.414s-2.371-2.625-1.928-5.312,2.025-4.661,3.534-4.414S313.388,128.605,312.945,131.291Z",
    transform: "translate(-307.366 -125.959)",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26087",
    "data-name": "Group 26087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26086",
    "data-name": "Group 26086"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26085",
    "data-name": "Group 26085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26084",
    "data-name": "Group 26084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26083",
    "data-name": "Group 26083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26082",
    "data-name": "Group 26082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26081",
    "data-name": "Group 26081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26080",
    "data-name": "Group 26080"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52130",
    "data-name": "Path 52130",
    d: "M292.129,123.521c1.087-2.733,4.335-7.672,13.5-6.583a2.418,2.418,0,0,1,2.117,2.146h0a2.4,2.4,0,0,1-2.349,2.664,10.83,10.83,0,0,0-8.855,4.367,2.414,2.414,0,0,1-3.519.342l-.245-.214A2.415,2.415,0,0,1,292.129,123.521Z",
    transform: "translate(-291.955 -116.784)",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26095",
    "data-name": "Group 26095",
    transform: "translate(33.224 3.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26094",
    "data-name": "Group 26094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26093",
    "data-name": "Group 26093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26092",
    "data-name": "Group 26092"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26091",
    "data-name": "Group 26091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26090",
    "data-name": "Group 26090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26089",
    "data-name": "Group 26089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26088",
    "data-name": "Group 26088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52131",
    "data-name": "Path 52131",
    d: "M320.317,129.069c-.151-2.936-1.642-8.653-10.677-10.549a2.423,2.423,0,0,0-2.693,1.357h0a2.4,2.4,0,0,0,1.368,3.273,10.8,10.8,0,0,1,6.984,6.968,2.412,2.412,0,0,0,3.226,1.444l.3-.124A2.422,2.422,0,0,0,320.317,129.069Z",
    transform: "translate(-306.723 -118.468)",
    fill: "#341a1b"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26112",
    "data-name": "Group 26112",
    transform: "translate(12.576 92.497)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26111",
    "data-name": "Group 26111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26110",
    "data-name": "Group 26110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26109",
    "data-name": "Group 26109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26108",
    "data-name": "Group 26108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26107",
    "data-name": "Group 26107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26106",
    "data-name": "Group 26106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26105",
    "data-name": "Group 26105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52133",
    "data-name": "Path 52133",
    d: "M287.892,136.727c-.175.277-5.08,7.894-10.578,9.46l-.022-.034.628-5.694S282.47,140.432,287.892,136.727Z",
    transform: "translate(-277.291 -136.727)",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26120",
    "data-name": "Group 26120",
    transform: "translate(0 63.594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26119",
    "data-name": "Group 26119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26118",
    "data-name": "Group 26118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26117",
    "data-name": "Group 26117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26116",
    "data-name": "Group 26116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26115",
    "data-name": "Group 26115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26114",
    "data-name": "Group 26114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26113",
    "data-name": "Group 26113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52134",
    "data-name": "Path 52134",
    d: "M293.02,133.318s-8.4-16.2-18.167-6.155c-8.05,8.275.236,34.64,14.493,28.41Z",
    transform: "translate(-271.701 -123.88)",
    fill: "#ffae95"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26128",
    "data-name": "Group 26128",
    transform: "translate(7.095 70.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26127",
    "data-name": "Group 26127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26126",
    "data-name": "Group 26126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26125",
    "data-name": "Group 26125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26124",
    "data-name": "Group 26124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26123",
    "data-name": "Group 26123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26122",
    "data-name": "Group 26122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26121",
    "data-name": "Group 26121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52135",
    "data-name": "Path 52135",
    d: "M284.648,146.979a1.09,1.09,0,0,0,.121.013,1.121,1.121,0,0,0,1.184-1.057,20.949,20.949,0,0,0-9.393-18.687,1.121,1.121,0,1,0-1.163,1.917h0a18.7,18.7,0,0,1,8.311,16.648A1.123,1.123,0,0,0,284.648,146.979Z",
    transform: "translate(-274.855 -127.087)",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26136",
    "data-name": "Group 26136",
    transform: "translate(6.7 78.443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26135",
    "data-name": "Group 26135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26134",
    "data-name": "Group 26134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26133",
    "data-name": "Group 26133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26132",
    "data-name": "Group 26132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26131",
    "data-name": "Group 26131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26130",
    "data-name": "Group 26130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26129",
    "data-name": "Group 26129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52136",
    "data-name": "Path 52136",
    d: "M275.624,134.341a1.131,1.131,0,0,0,.738-.13h0c1.093-.621,4.335-2.056,6.167-1.255a1.12,1.12,0,1,0,.9-2.05c-3.192-1.4-7.683,1.073-8.185,1.359a1.117,1.117,0,0,0,.378,2.077Z",
    transform: "translate(-274.679 -130.48)",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26144",
    "data-name": "Group 26144",
    transform: "translate(64.789 67.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26143",
    "data-name": "Group 26143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26142",
    "data-name": "Group 26142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26141",
    "data-name": "Group 26141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26140",
    "data-name": "Group 26140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26139",
    "data-name": "Group 26139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26138",
    "data-name": "Group 26138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26137",
    "data-name": "Group 26137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52137",
    "data-name": "Path 52137",
    d: "M302.42,147.322c6.574,1.078,9.546-3.132,9.669-3.312a1.115,1.115,0,0,0,.148-.952c-2.979-9.991-5.975-20.25-6-20.354a1.124,1.124,0,0,0-2.16.625c.029.1,2.916,9.98,5.838,19.793-.785.826-3.042,2.657-7.127,1.987a1.121,1.121,0,1,0-.364,2.212Z",
    transform: "translate(-301.477 -121.897)",
    fill: "#341a1b"
  })))))))))))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_26262",
    "data-name": "Group 26262",
    transform: "translate(0 312.926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26261",
    "data-name": "Group 26261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26204",
    "data-name": "Group 26204",
    transform: "translate(14.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26178",
    "data-name": "Group 26178",
    transform: "translate(0 207.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26154",
    "data-name": "Group 26154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26153",
    "data-name": "Group 26153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26152",
    "data-name": "Group 26152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26151",
    "data-name": "Group 26151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26150",
    "data-name": "Group 26150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26149",
    "data-name": "Group 26149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52138",
    "data-name": "Path 52138",
    d: "M326.721,359.646s-3.773,1.579-9.879,4.257c-1.741.763-3.667,1.611-5.748,2.538-2.76,1.231-5.8,2.594-9.024,4.072q-2.763,1.262-5.707,2.63c-24.352,11.316-56.35,27.447-68.143,39.04-.828.814-1.627,1.615-2.392,2.412-17.8,18.439-19.474,31.427-23.857,29.8-4.574-1.69-7.717-11.971-2.623-20.261,3.53-5.746,5.224-13.384,9.719-22.216a70.425,70.425,0,0,1,4.351-7.413c7.582-11.253,20.835-24.041,27.807-33.184.45-.589.873-1.165,1.269-1.723,5.638-7.987,5.526-21.915,17.481-28.714,5.843-3.321,13.519-4.158,21.173-3.8,1.361.065,2.722.166,4.068.3,2.016.2,4,.466,5.926.772,2.661.434,5.2.947,7.539,1.485,2.241.511,4.292,1.044,6.068,1.539,4.286,1.195,6.99,2.182,6.99,2.182Z",
    transform: "translate(-196.732 -327.011)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26159",
    "data-name": "Group 26159",
    transform: "translate(44.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26158",
    "data-name": "Group 26158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26157",
    "data-name": "Group 26157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26156",
    "data-name": "Group 26156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26155",
    "data-name": "Group 26155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52139",
    "data-name": "Path 52139",
    d: "M256.431,327.087c-5.456,11.544-18.851,34.246-39.922,34.237.45-.589.873-1.165,1.269-1.723,5.638-7.987,5.525-21.915,17.481-28.714C241.1,327.567,248.777,326.73,256.431,327.087Z",
    transform: "translate(-216.509 -327.011)",
    fill: "#0f1b30"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26164",
    "data-name": "Group 26164",
    transform: "translate(0 74.91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26163",
    "data-name": "Group 26163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26162",
    "data-name": "Group 26162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26161",
    "data-name": "Group 26161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26160",
    "data-name": "Group 26160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52140",
    "data-name": "Path 52140",
    d: "M225.828,372.981c-17.8,18.439-19.474,31.427-23.857,29.8-4.574-1.69-7.717-11.971-2.623-20.262,3.53-5.746,5.224-13.384,9.719-22.216C215,362.857,221.578,366.864,225.828,372.981Z",
    transform: "translate(-196.732 -360.308)",
    fill: "#6e3e45"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26170",
    "data-name": "Group 26170",
    transform: "translate(101.948 2.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26169",
    "data-name": "Group 26169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26168",
    "data-name": "Group 26168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26167",
    "data-name": "Group 26167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26166",
    "data-name": "Group 26166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26165",
    "data-name": "Group 26165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52141",
    "data-name": "Path 52141",
    d: "M260.209,362.44c-1.741.762-3.667,1.611-5.748,2.538-5.269-6.106-8.977-14.133-10.92-23.78a80.357,80.357,0,0,1-1.494-13.017c2.241.511,4.293,1.044,6.068,1.539a73.849,73.849,0,0,0,1.316,10.34C250.969,347.657,254.076,356.073,260.209,362.44Z",
    transform: "translate(-242.047 -328.181)",
    fill: "#0f1b30"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26177",
    "data-name": "Group 26177",
    transform: "translate(87.897 0.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26176",
    "data-name": "Group 26176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26175",
    "data-name": "Group 26175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26174",
    "data-name": "Group 26174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26173",
    "data-name": "Group 26173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26172",
    "data-name": "Group 26172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26171",
    "data-name": "Group 26171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52142",
    "data-name": "Path 52142",
    d: "M242.313,327.95c-1.926-.306-3.91-.571-5.926-.771a80.955,80.955,0,0,0-.218,17.382c1.159,11.681,5.044,21.323,11.366,28.374q2.939-1.363,5.708-2.63C240.32,357.482,241.346,336.141,242.313,327.95Z",
    transform: "translate(-235.802 -327.178)",
    fill: "#0f1b30"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26183",
    "data-name": "Group 26183",
    transform: "translate(114.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26182",
    "data-name": "Group 26182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26181",
    "data-name": "Group 26181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26180",
    "data-name": "Group 26180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26179",
    "data-name": "Group 26179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141913",
    "data-name": "Path 141913",
    d: "M-19989.812-1869.437c16.129-3.5,38.984-45.59,34.414-68.68s-28.937-19.633-28.937-19.633v39.293Z",
    transform: "translate(20264.484 1980.294)",
    fill: "#bf3120"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52143",
    "data-name": "Path 52143",
    d: "M247.755,437c-1.892,40.1,23.078,42.608,23.078,42.608s5.136-.121,17-3.271q1.667-.445,3.507-.965c7.692-2.193,17.75-5.516,30.484-10.556q2.258-.9,4.641-1.874c8.347-3.4,17.755-7.512,28.3-12.461,15.944-7.476,34.482-16.855,55.884-28.66,61.673-33.994,115.968-81.437,136.211-120.785,13.676-26.547,11.82-49.414-13.764-61.961a43.2,43.2,0,0,0-14.079-4.056c-32.408-3.759-65.119,27.121-65.119,27.121-65.729,44.077-86.2,81.655-113.1,111.845q-1.664,1.876-3.368,3.712c-.734.79-1.483,1.566-2.259,2.351a159.158,159.158,0,0,1-14.637,12.977c-17.71,14.034-39.227,26.522-54.255,34.568q-1.593.854-3.082,1.638C253.9,434.136,247.755,437,247.755,437Z",
    transform: "translate(-247.653 -234.706)",
    fill: "#0f1b30"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26203",
    "data-name": "Group 26203",
    transform: "translate(108.119 195.356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26202",
    "data-name": "Group 26202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26201",
    "data-name": "Group 26201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26200",
    "data-name": "Group 26200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26199",
    "data-name": "Group 26199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52147",
    "data-name": "Path 52147",
    d: "M259.064,321.881c6.047,19.884,14.457,37.457,28.345,49.671,0,0-8.623,8.749-18.466,5.2-7.516-2.713-26.138-32.2-23.98-50.005C250.167,322.638,254.932,320.7,259.064,321.881Z",
    transform: "translate(-244.79 -321.54)",
    fill: "#070e1a"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26260",
    "data-name": "Group 26260",
    transform: "translate(0 10.294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26234",
    "data-name": "Group 26234",
    transform: "translate(304.239 192.184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26210",
    "data-name": "Group 26210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26209",
    "data-name": "Group 26209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26208",
    "data-name": "Group 26208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26207",
    "data-name": "Group 26207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26206",
    "data-name": "Group 26206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26205",
    "data-name": "Group 26205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52148",
    "data-name": "Path 52148",
    d: "M325.595,359.8s3.847,1.388,10.081,3.759c1.775.675,3.741,1.424,5.865,2.245,2.819,1.093,5.917,2.3,9.215,3.62q2.825,1.123,5.831,2.342c24.887,10.09,57.648,24.6,70.006,35.6.866.772,1.706,1.534,2.509,2.29,18.7,17.53,21.015,30.417,25.31,28.579,4.486-1.915,7.112-12.34,1.611-20.367-3.811-5.561-5.883-13.107-10.812-21.7a70.819,70.819,0,0,0-4.715-7.188c-8.133-10.862-22.007-22.972-29.427-31.758-.477-.565-.929-1.12-1.352-1.658-6.029-7.7-6.61-21.611-18.889-27.807-6-3.024-13.71-3.478-21.337-2.738-1.357.131-2.711.3-4.047.5-2,.3-3.971.666-5.881,1.066-2.634.567-5.15,1.206-7.456,1.858-2.212.623-4.234,1.258-5.982,1.84-4.223,1.406-6.873,2.529-6.873,2.529Z",
    transform: "translate(-325.595 -324.706)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26215",
    "data-name": "Group 26215",
    transform: "translate(43.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26214",
    "data-name": "Group 26214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26213",
    "data-name": "Group 26213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26212",
    "data-name": "Group 26212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26211",
    "data-name": "Group 26211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52149",
    "data-name": "Path 52149",
    d: "M345.106,325.017c6.023,11.258,20.534,33.263,41.578,32.2-.477-.565-.929-1.12-1.352-1.658-6.029-7.7-6.61-21.611-18.889-27.807C360.443,324.731,352.733,324.277,345.106,325.017Z",
    transform: "translate(-345.106 -324.706)",
    fill: "#0f1b30"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26220",
    "data-name": "Group 26220",
    transform: "translate(103.507 71.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26219",
    "data-name": "Group 26219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26218",
    "data-name": "Group 26218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26217",
    "data-name": "Group 26217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26216",
    "data-name": "Group 26216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52150",
    "data-name": "Path 52150",
    d: "M371.6,369.961c18.7,17.53,21.015,30.417,25.31,28.579,4.486-1.915,7.112-12.34,1.611-20.367-3.811-5.561-5.883-13.107-10.812-21.7C381.916,359.31,375.542,363.641,371.6,369.961Z",
    transform: "translate(-371.603 -356.469)",
    fill: "#070e1a"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26226",
    "data-name": "Group 26226",
    transform: "translate(10.081 3.735)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26225",
    "data-name": "Group 26225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26224",
    "data-name": "Group 26224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26223",
    "data-name": "Group 26223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26222",
    "data-name": "Group 26222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26221",
    "data-name": "Group 26221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52151",
    "data-name": "Path 52151",
    d: "M330.076,361.489c1.775.675,3.741,1.424,5.865,2.245,4.958-6.36,8.261-14.563,9.724-24.293a80.424,80.424,0,0,0,.841-13.076c-2.212.623-4.234,1.258-5.982,1.84a73.952,73.952,0,0,1-.8,10.392C338.567,346.265,335.88,354.823,330.076,361.489Z",
    transform: "translate(-330.076 -326.366)",
    fill: "#0f1b30"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26233",
    "data-name": "Group 26233",
    transform: "translate(25.161 0.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26232",
    "data-name": "Group 26232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26231",
    "data-name": "Group 26231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26230",
    "data-name": "Group 26230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26229",
    "data-name": "Group 26229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26228",
    "data-name": "Group 26228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26227",
    "data-name": "Group 26227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52152",
    "data-name": "Path 52152",
    d: "M336.779,368.979q2.824,1.123,5.831,2.342c5.962-7.357,9.363-17.181,9.939-28.9a81.022,81.022,0,0,0-1.084-17.35c-2,.3-3.971.666-5.881,1.066C346.959,334.265,349.047,355.53,336.779,368.979Z",
    transform: "translate(-336.779 -325.066)",
    fill: "#0f1b30"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26239",
    "data-name": "Group 26239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26238",
    "data-name": "Group 26238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26237",
    "data-name": "Group 26237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26236",
    "data-name": "Group 26236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26235",
    "data-name": "Group 26235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52153",
    "data-name": "Path 52153",
    d: "M202.694,311.237c23.661,37.378,80.832,76.895,141.948,106.717,58.266,28.433,94.854,41.9,115.988,48.268.7.214,1.393.419,2.059.61,15.807,4.639,22.2,5.053,22.2,5.053s24.815-3.746,20.93-43.706c0,0-7.321-5.73-18.268-14.291q-1.424-1.107-2.916-2.281c-20.824-16.286-52.4-40.979-73.092-57.133-57.963-45.254-63.331-42.642-116.76-87.059,0,0-33.63-29.9-64.514-28.052a45,45,0,0,0-19.3,5.359C184.777,259.218,185.317,283.8,202.694,311.237Z",
    transform: "translate(-190.363 -239.281)",
    fill: "#0f1b30"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26259",
    "data-name": "Group 26259",
    transform: "translate(281.568 182.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26258",
    "data-name": "Group 26258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26257",
    "data-name": "Group 26257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26256",
    "data-name": "Group 26256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26255",
    "data-name": "Group 26255"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52157",
    "data-name": "Path 52157",
    d: "M341.354,320.752c-5.051,20.158-12.574,38.131-25.836,51.02,0,0,9.048,8.311,18.7,4.272,7.373-3.082,24.5-33.465,21.458-51.137C350.277,321.062,345.424,319.37,341.354,320.752Z",
    transform: "translate(-315.518 -320.275)",
    fill: "#070e1a"
  })))))))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_26284",
    "data-name": "Group 26284",
    transform: "translate(250.33 160.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26266",
    "data-name": "Group 26266",
    transform: "translate(37.618 41.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26265",
    "data-name": "Group 26265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26264",
    "data-name": "Group 26264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26263",
    "data-name": "Group 26263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52158",
    "data-name": "Path 52158",
    d: "M413.314,318.788c-8.635,20.286-28.574,19.463-49.868-11.584a562.013,562.013,0,0,1-31.553-52.5c-5.663-10.61-10.257-19.91-13.539-26.786q.5-8.278.8-16.563l41.274-26.12s13.125,20.734,26.491,46.332C403.447,263.2,420.345,302.266,413.314,318.788Z",
    transform: "translate(-318.354 -185.233)",
    fill: "#ffae95"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26270",
    "data-name": "Group 26270",
    transform: "translate(0 143.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26269",
    "data-name": "Group 26269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26268",
    "data-name": "Group 26268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26267",
    "data-name": "Group 26267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52159",
    "data-name": "Path 52159",
    d: "M301.633,304.933c18.479-12.437,41.2-27.06,50.188-35,22.18-19.575,61.1-50.93,81.216-35.213,0,0,16.524,32.675-11.022,54.021-26.243,20.336-84.917,42.734-112.267,51.234C306.672,328.372,303.145,316.808,301.633,304.933Z",
    transform: "translate(-301.633 -230.458)",
    fill: "#ffae95"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26279",
    "data-name": "Group 26279",
    transform: "translate(78.443 142.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26274",
    "data-name": "Group 26274",
    transform: "translate(0 0.254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26273",
    "data-name": "Group 26273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26272",
    "data-name": "Group 26272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26271",
    "data-name": "Group 26271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52160",
    "data-name": "Path 52160",
    d: "M337.931,247.74a1.357,1.357,0,0,0,.826-.326c10.313-8.81,24.884-14.225,25.031-14.279a1.369,1.369,0,0,0-.945-2.569c-.614.227-15.181,5.642-25.863,14.767a1.368,1.368,0,0,0,.952,2.407Z",
    transform: "translate(-336.5 -230.48)",
    fill: "#ef9073"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26283",
    "data-name": "Group 26283",
    transform: "translate(36.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26282",
    "data-name": "Group 26282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26281",
    "data-name": "Group 26281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26280",
    "data-name": "Group 26280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52162",
    "data-name": "Path 52162",
    d: "M391.27,252.059s-1.251.92-3.561,2.427c-8.142,5.321-29.409,17.942-55.024,23.137-2.072.423-4.18.8-6.306,1.111,0,0-3.568-3.5-8.657-9.2q.867-9.338,1.424-18.7.5-8.278.8-16.563c.839-22.437.736-44.923.661-67.383C337.838,177.293,364.885,200.62,391.27,252.059Z",
    transform: "translate(-317.721 -166.892)",
    fill: "#4cb8b6"
  }))))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_26310",
    "data-name": "Group 26310",
    transform: "translate(23.738 152.291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26288",
    "data-name": "Group 26288",
    transform: "translate(2.107 49.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26287",
    "data-name": "Group 26287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26286",
    "data-name": "Group 26286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26285",
    "data-name": "Group 26285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52163",
    "data-name": "Path 52163",
    d: "M256.369,185.234s-65.6,103.66-52.881,133.553c8.632,20.284,28.574,19.467,49.864-11.582,29.967-43.7,50.827-91.721,50.827-91.721Z",
    transform: "translate(-201.851 -185.234)",
    fill: "#ffae95"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26292",
    "data-name": "Group 26292",
    transform: "translate(0 151.079)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26291",
    "data-name": "Group 26291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26290",
    "data-name": "Group 26290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26289",
    "data-name": "Group 26289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52164",
    "data-name": "Path 52164",
    d: "M337.235,304.933c-18.48-12.437-41.2-27.06-50.188-35-22.18-19.575-61.1-50.93-81.216-35.213,0,0-16.527,32.675,11.022,54.021C243.1,309.08,301.77,331.478,329.12,339.978,332.2,328.372,335.721,316.808,337.235,304.933Z",
    transform: "translate(-200.915 -230.458)",
    fill: "#ffae95"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26301",
    "data-name": "Group 26301",
    transform: "translate(29.694 150.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26296",
    "data-name": "Group 26296",
    transform: "translate(0 0.254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26295",
    "data-name": "Group 26295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26294",
    "data-name": "Group 26294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26293",
    "data-name": "Group 26293"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52165",
    "data-name": "Path 52165",
    d: "M240.867,247.74a1.363,1.363,0,0,1-.828-.326c-10.313-8.81-24.882-14.225-25.029-14.279a1.369,1.369,0,1,1,.945-2.569c.614.227,15.181,5.642,25.863,14.767a1.368,1.368,0,0,1-.952,2.407Z",
    transform: "translate(-214.114 -230.48)",
    fill: "#ef9073"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26305",
    "data-name": "Group 26305",
    transform: "translate(26.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26304",
    "data-name": "Group 26304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26303",
    "data-name": "Group 26303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26302",
    "data-name": "Group 26302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52167",
    "data-name": "Path 52167",
    d: "M301.693,163.3s-45.389,8.277-88.964,93.235c0,0,29.053,21.359,64.892,26.675,0,0,32.846-32.241,41.555-60.449S318.389,173.832,301.693,163.3Z",
    transform: "translate(-212.729 -163.305)",
    fill: "#4cb8b6"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M20369.893,2190.522a1.1,1.1,0,0,1,.133-1.552c22.275-18.725,35.135-47.106,35.262-47.388a1.1,1.1,0,0,1,2.01.9,147.437,147.437,0,0,1-8.285,15.152,42.374,42.374,0,0,0,12.307-6.146,1.1,1.1,0,0,1,1.332,1.757c-.3.231-7.379,5.544-15.311,7.045-6.1,9.489-14.855,21.085-25.895,30.364a1.114,1.114,0,0,1-.713.261A1.084,1.084,0,0,1,20369.893,2190.522Z",
    transform: "translate(-20285.787 -2071.007)",
    fill: "#0e1a2f",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26312",
    "data-name": "Group 26312",
    transform: "translate(291.178 168.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26311",
    "data-name": "Group 26311",
    opacity: 0.097,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52170",
    "data-name": "Path 52170",
    d: "M323.71,230.836a1.1,1.1,0,0,0,1.1-1.017c.128-1.687,3.06-41.483-2.875-58.512a1.1,1.1,0,0,0-2.081.724c5.784,16.6,2.79,57.212,2.76,57.621a1.1,1.1,0,0,0,1.015,1.181Z",
    transform: "translate(-319.79 -170.567)",
    fill: "#0e1a2f"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_26329",
    "data-name": "Group 26329",
    transform: "translate(132.131 314.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26315",
    "data-name": "Group 26315",
    transform: "translate(0 92.138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26314",
    "data-name": "Group 26314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26313",
    "data-name": "Group 26313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52171",
    "data-name": "Path 52171",
    d: "M262.871,313.6l-12.729-24.212a9.009,9.009,0,0,1,8.072-13.2l200.107,2.157-5.9,31Z",
    transform: "translate(-249.094 -276.187)",
    fill: "#cecece"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26318",
    "data-name": "Group 26318",
    transform: "translate(13.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26317",
    "data-name": "Group 26317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26316",
    "data-name": "Group 26316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52172",
    "data-name": "Path 52172",
    d: "M441.054,361.524H261.971a6.872,6.872,0,0,1-6.961-7.824l12.21-110.643a8.965,8.965,0,0,1,8.689-7.825H454.989a6.875,6.875,0,0,1,6.963,7.825L449.742,353.7A8.963,8.963,0,0,1,441.054,361.524Z",
    transform: "translate(-254.962 -235.232)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26321",
    "data-name": "Group 26321",
    transform: "translate(16.606 5.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26320",
    "data-name": "Group 26320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26319",
    "data-name": "Group 26319"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52173",
    "data-name": "Path 52173",
    d: "M257.988,359.418a1.367,1.367,0,0,1-.191-.011,1.508,1.508,0,0,1-1.309-1.687l14.864-118.511a1.51,1.51,0,0,1,3,.378L259.484,358.1A1.511,1.511,0,0,1,257.988,359.418Z",
    transform: "translate(-256.476 -237.888)",
    fill: "#cecece"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26328",
    "data-name": "Group 26328",
    transform: "translate(12.593 112.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26327",
    "data-name": "Group 26327"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26326",
    "data-name": "Group 26326"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52175",
    "data-name": "Path 52175",
    d: "M442.828,305.252H261.28a6.585,6.585,0,0,1-6.526-7.476l.782-12.653H451.326l-1.971,14.435A6.587,6.587,0,0,1,442.828,305.252Z",
    transform: "translate(-254.692 -285.123)",
    fill: "#fff"
  }))))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_26353",
    "data-name": "Group 26353",
    transform: "translate(0 353.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26334",
    "data-name": "Group 26334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26333",
    "data-name": "Group 26333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26332",
    "data-name": "Group 26332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26331",
    "data-name": "Group 26331"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52176",
    "data-name": "Path 52176",
    d: "M130.049,349.819s-1.964-11.643-.556-29.47a69.173,69.173,0,0,1,49.24-60.874c22.648-6.691,52.545-10.826,83.138-1.577,2.241.677,4.5,1.429,6.743,2.254,65.308,24.012,55.7,148.874,45.137,218.985s-11.526,112.373-41.3,119.1c-13.672,3.087-33.618,3.336-51.2,2.709-3.66-.13-7.219-.3-10.6-.491,0,0-37.015,3.222-56-13.053S130.049,349.819,130.049,349.819Z",
    transform: "translate(-128.985 -252.525)",
    fill: "#e84430"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_141911",
    "data-name": "Path 141911",
    d: "M-20443.295-1592.079s-1.453-43.824-48.5-38.065,36.744,36.315,36.744,36.315Z",
    transform: "translate(20531.457 1940.206)",
    fill: "#c13120"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26339",
    "data-name": "Group 26339",
    transform: "translate(92.263 5.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26338",
    "data-name": "Group 26338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26337",
    "data-name": "Group 26337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26336",
    "data-name": "Group 26336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26335",
    "data-name": "Group 26335"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52177",
    "data-name": "Path 52177",
    d: "M169.995,597.959c17.584.628,37.53.378,51.2-2.709,29.776-6.725,30.736-48.98,41.3-119.1s20.171-194.973-45.137-218.985c-2.248-.826-4.5-1.577-6.743-2.254-11.129,2.657-21.357,10.041-26.876,26.266C168.778,325.184,192.535,478.092,169.995,597.959Z",
    transform: "translate(-169.995 -254.913)",
    fill: "#f45642"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_141915",
    "data-name": "Path 141915",
    d: "M426.774,284.09a1.324,1.324,0,0,0,.295-.031,1.356,1.356,0,0,0,1.03-1.617c-.2-.893-5.048-21.929-22.574-26.115-7.1-1.7-13.409-.423-18.747,3.789-7.717,6.092-11.314,17.1-11.314,22.621a1.357,1.357,0,0,0,2.713,0c0-4.317,3.017-14.758,10.281-20.493,4.652-3.669,10.182-4.774,16.437-3.278,15.892,3.8,20.511,23.861,20.556,24.064A1.355,1.355,0,0,0,426.774,284.09Z",
    transform: "translate(-259.489 -229.684)",
    fill: "#d63925"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_141914",
    "data-name": "Path 141914",
    d: "M-20056.672-1679.361c-14.832,20.758-15.275,34.354-8.447,44.592a28.414,28.414,0,0,0,17.82,11.881l-3.385,25.947,29.424-4.668s7.7-33.521,7.768-37.842-15.693-17.99-15.693-17.99l-18.113-8.844S-20041.84-1700.119-20056.672-1679.361Z",
    transform: "translate(20531.457 2293.22)",
    fill: "#c13120"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27145",
    "data-name": "Group 27145",
    transform: "matrix(0.999, 0.035, -0.035, 0.999, 360.107, 356.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27144",
    "data-name": "Group 27144",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52906",
    "data-name": "Path 52906",
    d: "M52.631,24.181a49.433,49.433,0,0,0-.671-6.042,58.143,58.143,0,0,0-1.58-6.718,14.681,14.681,0,0,0-2.958-5.585A13.123,13.123,0,0,0,42.836,2.5a22.545,22.545,0,0,0-4.547-1.354A42.607,42.607,0,0,0,33.2.348C31.553.2,29.9.064,28.242.024,26.335-.022,24.423,0,22.517.069a44.661,44.661,0,0,0-5.6.6,45.308,45.308,0,0,0-4.968,1.064A13.408,13.408,0,0,0,5.077,6.011,14.558,14.558,0,0,0,2.265,11.5,63.431,63.431,0,0,0,.6,18.8a41.8,41.8,0,0,0-.508,4.77c-.022.509-.06,1.018-.09,1.526V27.71c.014.1.033.206.042.309.124,1.459.2,2.924.38,4.376a47.437,47.437,0,0,0,1.2,6.158,31.261,31.261,0,0,0,1.324,4.291,12.942,12.942,0,0,0,6.289,6.742,20.031,20.031,0,0,0,5.045,1.671c2.046.421,4.118.647,6.191.864a54.052,54.052,0,0,0,7.352.3c1.155-.037,2.31-.131,3.462-.233,1.2-.107,2.406-.227,3.6-.392a34.451,34.451,0,0,0,7-1.531A12.944,12.944,0,0,0,48.1,45.749a14.629,14.629,0,0,0,2.081-4.227A46.471,46.471,0,0,0,52,34.218c.24-1.549.4-3.112.551-4.674a37.452,37.452,0,0,0,.083-5.363",
    transform: "translate(0 -0.001)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52907",
    "data-name": "Path 52907",
    d: "M222.608,24.385h-.524V21.667h-1.146V21.2h2.816v.467h-1.146Z",
    transform: "translate(-167.261 -15.947)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52908",
    "data-name": "Path 52908",
    d: "M238.179,24.385l-.854-1.684c-.1-.287-.181-.534-.248-.776.017.281.028.585.028.821v1.639h-.5V21.2h.645l.915,1.836c.115.326.132.366.22.663.11-.337.154-.461.22-.652l.909-1.831h.645v3.168h-.5V22.746c0-.259.011-.528.027-.821-.088.3-.155.517-.27.821l-.832,1.639Z",
    transform: "translate(-179.124 -15.947)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52909",
    "data-name": "Path 52909",
    d: "M137.1,44.24h5.366a.149.149,0,0,1,.147.15V74.6a.149.149,0,0,1-.147.15H137.1a.149.149,0,0,1-.147-.15V44.39a.149.149,0,0,1,.147-.15",
    transform: "translate(-103.68 -33.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52910",
    "data-name": "Path 52910",
    d: "M54.877,44.24h5.366a.149.149,0,0,1,.147.15V74.6a.149.149,0,0,1-.147.15H54.877a.149.149,0,0,1-.147-.15V44.39a.149.149,0,0,1,.147-.15",
    transform: "translate(-41.433 -33.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52911",
    "data-name": "Path 52911",
    d: "M70.146,85.481a19.549,19.549,0,0,0-9.74,4.393c-3.733,3.312-5.642,8.079-5.673,14.17a.153.153,0,0,0,.149.155h5.366a.148.148,0,0,0,.145-.149c.028-4.335,1.28-7.633,3.709-9.8a13.35,13.35,0,0,1,6.043-2.892Z",
    transform: "translate(-41.436 -64.298)",
    fill: "#fff"
  })))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27296",
    "data-name": "Group 27296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52991",
    "data-name": "Path 52991",
    d: "M393.535,450.6c0,8.161-56.956,14.777-127.212,14.777S139.11,458.759,139.11,450.6s56.955-14.777,127.212-14.777S393.535,442.436,393.535,450.6Z",
    transform: "translate(1027.549 537.246)",
    fill: "#070e1c",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27241",
    "data-name": "Group 27241",
    transform: "translate(1194.662 733.639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27240",
    "data-name": "Group 27240",
    transform: "translate(0.001)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27239",
    "data-name": "Group 27239",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27238",
    "data-name": "Group 27238",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52912",
    "data-name": "Path 52912",
    d: "M69.185,2495.388c-3.543,13.114-38.287,12.161-47.224,7.206-9.674-5.364-12.225-27.647,20.866-24.388,2.668.263,11.468,2.314,14.942,9.906",
    transform: "translate(-14.188 -2256.253)",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27150",
    "data-name": "Group 27150",
    transform: "translate(1.394 221.629)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27149",
    "data-name": "Group 27149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27148",
    "data-name": "Group 27148",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52913",
    "data-name": "Path 52913",
    d: "M42.835,2482.09c-18.627-1.835-25.961,4.421-27.089,11.2-1.261-7.982,4.907-17.275,27.089-15.087,2.667.261,11.47,2.314,14.943,9.905,0,0-12.276-5.759-14.943-6.02",
    transform: "translate(-15.591 -2477.88)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27153",
    "data-name": "Group 27153",
    transform: "translate(1.393 231.007)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27152",
    "data-name": "Group 27152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27151",
    "data-name": "Group 27151",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52914",
    "data-name": "Path 52914",
    d: "M69.176,2590.853c-3.54,13.114-38.287,12.163-47.224,7.207-4.812-2.667-7.859-9.521-5.64-15.334a12.829,12.829,0,0,0,5.64,6.982c7.394,4.1,32.446,5.46,42.887-1.617Z",
    transform: "translate(-15.575 -2582.726)",
    fill: "#1d1c22"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52916",
    "data-name": "Path 52916",
    d: "M251.013,2557.316a22.64,22.64,0,0,0-4.082,4.752,8.123,8.123,0,0,0-.976,2.72,8.738,8.738,0,0,0,.029,2.884,18.011,18.011,0,0,0,1.925,5.725,8.526,8.526,0,0,0,1.693,2.205,3.869,3.869,0,0,0,2.1,1.028l.027,0a1.409,1.409,0,0,1-.3,2.8,6,6,0,0,1-2.055-.555,7.033,7.033,0,0,1-1.694-1.142,10.533,10.533,0,0,1-2.251-3.007,16.694,16.694,0,0,1-1.289-3.313,18.79,18.79,0,0,1-.635-3.452,11.829,11.829,0,0,1-.038-1.807l.087-.929c.037-.308.129-.609.193-.912a10.094,10.094,0,0,1,4.028-5.791,8.9,8.9,0,0,1,3.126-1.422.12.12,0,0,1,.108.206Z",
    transform: "translate(-221.681 -2330.279)",
    fill: "#1d1c22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52917",
    "data-name": "Path 52917",
    d: "M113.671,2563.512a18.871,18.871,0,0,0-3.06,4.423,7.691,7.691,0,0,0-.667,2.418c-.016.208-.053.412-.054.621l0,.625c0,.417.072.86.1,1.286a11.808,11.808,0,0,0,1.694,4.745,12.836,12.836,0,0,0,1.568,1.964,11.941,11.941,0,0,0,.925.848c.161.133.323.26.486.381s.351.246.45.309l.094.059a1.407,1.407,0,0,1-1.439,2.417c-.312-.174-.509-.3-.744-.462s-.44-.311-.645-.479a12.7,12.7,0,0,1-1.176-1.066,13.651,13.651,0,0,1-1.919-2.513,13.036,13.036,0,0,1-1.248-2.9c-.162-.5-.243-1.021-.364-1.53-.058-.518-.133-1.036-.16-1.552,0-.521-.037-1.024,0-1.554l.069-.8c.028-.264.1-.525.148-.786a9.793,9.793,0,0,1,1.148-2.944,8.46,8.46,0,0,1,2-2.344,6.845,6.845,0,0,1,2.68-1.375.121.121,0,0,1,.119.2Z",
    transform: "translate(-97.879 -2335.926)",
    fill: "#1d1c22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52918",
    "data-name": "Path 52918",
    d: "M348.872,1066.05H256.327l-16.394-1.656-24.017-2.423c.5,0-5.538-2.515-3.78-9.476.634-2.515-.359-2.6-2.839-5.668-3.812-4.724,4.2-13.622.754-17.07-1.293-1.293-5.816,2.638-8.345-1.451s4.012-16.937,1.994-20.734-7.641,1.832-3.692-16.045c2.98-13.477-2.822-4.8-3.871-10.5a6.222,6.222,0,0,1,.067-2.283c.99-5.2,6.823-12.417,6.992-13.5.342-2.156-2.892.268-4.34-2.325-2.42-4.329,3.709-8.014,3.28-10.49-.405-2.332-5.006-3.015-2.638-9.264,1.483-3.9,8.384-10.247,8.348-11.952-.053-2.269-3.847-1.131-2.638-6.355.532-2.307,2.779-4.794,5.178-7.013,3.036-2.815,6.312-5.2,6.64-6.249,4.928-3.758,4.047-5.611,4.488-5.611l4.977-.282,69.49-3.949a19.169,19.169,0,0,0,3.995,9.5c4.051,5.136,9.581,7.249,9.832,11.448.243,4.04-1.775,4.565-.719,6.749.726,1.5,4.992,2.617,5.9,5.647.74,2.466-2,2.353-1.145,4.093.74,1.494,3.5,2.3,3.716,4.375.169,1.638-.137,2.466.331,3.727,1.687,4.541,4.847,4.879,6.186,7.475,1.318,2.557.159,4.012.789,5.943,1.067,3.29,3.547,3.315,4.731,4.583,3.015,3.23,1.11,5.256,1.786,7.049,1.134,3.022,3.614,2.445,4.889,4.308,2.385,3.48.845,4.784,2.586,6.9Z",
    transform: "translate(-178.524 -821.101)",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27156",
    "data-name": "Group 27156",
    transform: "translate(17.68 84.605)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27155",
    "data-name": "Group 27155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27154",
    "data-name": "Group 27154",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52919",
    "data-name": "Path 52919",
    d: "M212.54,966.46c3.5,14.647-10.018,10.878-4.523,21.541s-7.859,9.472-2.748,13.784c5.788,4.886-1.793,6.89-7.6,17.159.99-5.2,6.823-12.417,6.992-13.5.342-2.156-2.892.268-4.34-2.325-2.42-4.329,3.709-8.014,3.279-10.49-.4-2.332-5.005-3.015-2.638-9.264,1.483-3.9,8.384-10.247,8.348-11.952-.053-2.269-3.847-1.131-2.638-6.355.532-2.307,2.779-4.794,5.178-7.013,3.036-2.815,6.312-5.2,6.64-6.249,4.928-3.759,4.047-5.611,4.488-5.611l4.977-.282.222.578s-17.236,13.3-15.637,19.977",
    transform: "translate(-197.668 -945.906)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27159",
    "data-name": "Group 27159",
    transform: "translate(114.597 80.656)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27158",
    "data-name": "Group 27158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27157",
    "data-name": "Group 27157",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52920",
    "data-name": "Path 52920",
    d: "M1318.2,977.433c-1.187-1.508-.342-3.417-3.357-6.647-1.184-1.268-3.663-1.3-4.731-4.586-.63-1.927.426-4.882-.891-7.44-1.339-2.6-2.664-2.038-4.819-5.951a12.9,12.9,0,0,1-1.454-4.684c-.215-2.071-2.706-2.869-3.446-4.362-.86-1.74.092-4-.647-6.462-.909-3.029-5.372-2.152-6.193-5.816-.528-2.367,1.969-2.473,1.726-6.513-.25-4.2-5.115-3.089-9.166-8.229a19.156,19.156,0,0,1-3.995-9.5l2.86-5.481a19.169,19.169,0,0,0,3.995,9.5c4.051,5.136,9.581,7.249,9.831,11.448.243,4.04-1.775,4.565-.719,6.749.726,1.5,4.991,2.617,5.9,5.647.74,2.466-2,2.353-1.145,4.093.74,1.494,3.5,2.3,3.716,4.375.169,1.638-.137,2.466.331,3.727,1.687,4.541,4.847,4.879,6.186,7.475,1.318,2.557.158,4.012.789,5.943,1.067,3.29,3.547,3.315,4.731,4.583,3.015,3.23,1.11,5.256,1.786,7.049,1.134,3.022,3.614,2.445,4.889,4.308,2.385,3.48-3.635,4.005-6.179.775",
    transform: "translate(-1281.227 -901.757)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52921",
    "data-name": "Path 52921",
    d: "M1899.606,1786.658s20,3.611,22.235-9.583,8.539-5.44,9.023-15.375,4.294-10.951,2.908-16.128c-1.615-6.031-16.83-10.043-17.865-1.562-.379,3.1-4.374.754-6.9,2.854-2.959,2.456-1.077,6.542-4.846,7-2.374.288-10.608-.269-11.335,12.924",
    transform: "translate(-1723.522 -1583.601)",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27162",
    "data-name": "Group 27162",
    transform: "translate(169.298 155.555)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27161",
    "data-name": "Group 27161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27160",
    "data-name": "Group 27160",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52922",
    "data-name": "Path 52922",
    d: "M1933.556,1744.967c-4.861-3.653-14.368-4.674-15.179,1.969-.377,3.1-4.375.754-6.9,2.853-2.959,2.455-1.078,6.541-4.847,7-2.374.289-10.606-.268-11.336,12.924l-2.476-2.927c.729-13.192,8.961-12.635,11.335-12.924,3.769-.458,1.888-4.544,4.847-7,2.529-2.1,6.524.246,6.9-2.857,1-8.194,15.239-4.724,17.655.962",
    transform: "translate(-1892.814 -1739.153)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27165",
    "data-name": "Group 27165",
    transform: "translate(169.298 158.279)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27164",
    "data-name": "Group 27164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27163",
    "data-name": "Group 27163",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52923",
    "data-name": "Path 52923",
    d: "M1930.858,1789.431c-.483,9.937-6.784,2.18-9.021,15.376s-22.238,9.581-22.238,9.581l-6.784-19.867c.021-.359,5.219-3.863,5.251-4.2l4.431,8.481c3.882,7.429,15.043,5.922,16.656-2.3q.052-.265.1-.54c2.237-13.2,8.539-5.439,9.021-15.376a30.04,30.04,0,0,1,2.585-10.969,7.092,7.092,0,0,1,2.91,3.692c1.385,5.175-2.423,6.193-2.91,16.126",
    transform: "translate(-1892.814 -1769.613)",
    fill: "#1d1c22"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52925",
    "data-name": "Path 52925",
    d: "M636.951,1477.889c0,14.821-11.917,30.967-22.078,38.34-6.085,4.416-8.487-6.543-12.445-6.543-11.643,0-11.858-16.637-23.095-31.151-2.585-3.339-.3-5.681-.781-13.92-.535-9.089,2.423-15.831,7.35-18.5,2.147-1.161,3.339-4.308,4.308-8.831,2.028-9.466,12.141-12.155,17.91-12.155,3.967,0,11.061,1.386,15.428,5.412,6.219,5.735,3.231,13.974,7.835,17.447,4.545,3.429,8.4,10.193,9.086,12.55,2.485,8.6-3.518,14.19-3.518,17.348",
    transform: "translate(-526.373 -1297.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27168",
    "data-name": "Group 27168",
    transform: "translate(43.847 169.964)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27167",
    "data-name": "Group 27167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27166",
    "data-name": "Group 27166",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52926",
    "data-name": "Path 52926",
    d: "M588.459,1975.238H527.541a5.413,5.413,0,0,1-4.854-3.018l-32.036-64.945a4.139,4.139,0,0,1,3.7-5.966l.171,0a17.812,17.812,0,0,1,2.2.089,5.452,5.452,0,0,1,4.816,4.656c.277,1.886,1.016,4.021,2.911,4.516a5.2,5.2,0,0,0,3.043-.2,5.563,5.563,0,0,1,6.329,1.823,4.616,4.616,0,0,0,3.471,2.176,4.471,4.471,0,0,0,3.162-1.4c1.787-1.7,4.6-2.3,6.567-.813,2.15,1.626,3.772,2.717,7.987,2.029,3.21-.524,3.276-3.672,6-5.735,2.456-1.857,4.717.849,6.026-4.659a4.954,4.954,0,0,1,4.329-3.415,12.408,12.408,0,0,1,5.584.517c2.219.735,5.886.4,8.8-.064a5.413,5.413,0,0,1,5.977,3.587,59.612,59.612,0,0,1,13.333,18.44c4.846,10.952.323,14.4,1.212,20.72s7.308,24.5,7.308,24.5a5.413,5.413,0,0,1-5.119,7.17",
    transform: "translate(-490.219 -1900.253)",
    fill: "#1d1c22"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27171",
    "data-name": "Group 27171",
    transform: "translate(31.862 80.656)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27170",
    "data-name": "Group 27170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27169",
    "data-name": "Group 27169",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52927",
    "data-name": "Path 52927",
    d: "M445.815,911.261c-.638,6.246-2.191,8.782-5.382,15.351-4.107,8.465-9.962,1.177-14.052,5.3-1.293,1.3-6.869,11.226-17.69,7.1-9.007-3.427-10.691-1.508-16.722.648s-10.282-7.109-19.385-7.218c-8.031-.092-6.478-14.062-16.359-14.6,3.036-2.815,6.313-5.2,6.64-6.249,4.928-3.759,4.047-5.611,4.488-5.611l74.467-4.231a19.17,19.17,0,0,0,3.995,9.5",
    transform: "translate(-356.225 -901.757)",
    fill: "#1d1c22"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52930",
    "data-name": "Path 52930",
    d: "M257.444,1972.11c.669,5.555,1.208,10.377.416,13.312-3.97,14.682-42.87,13.615-52.874,8.067-4-2.219-6.809-7.366-7.028-12.378a12.513,12.513,0,0,1,.782-5.08,10.327,10.327,0,0,1,6.108-5.953c1.31-.518,2.776-2.3,5.872-3.089,2.906-.733,3.431.768,4.977.638,2.237-.187,2.17-1.663,4.012-2.262,2.328-.754,4.185.623,5.245.7,3.022.211,3.653-2.335,8.3.514l-.011-.056L220.686,1907.3a4.187,4.187,0,0,0,3.477,2.057c.934.148,1.758.268,2.159.983,1.353,2.406-.624,7.595,3.139,7.743,3.463.137,5.58-.793,8.4,6.14s8.933-1.152,10.909,5.58c1.423,4.854,10.511,3.445,9.6,6.246-.954,2.917-4.477.479-4.16,2.638.264,1.821,3.892,4.583,4.241,6.623.564,3.286-2.959,2.744-2.73,4.586.356,2.906,3.716,5.59,2.8,8.067-.479,1.307-2.191,2.927-2.11,4.308.162,2.8,2.431,2.423,2.424,5.763,0,1.5-1.557,2.663-1.388,4.079",
    transform: "translate(-180.24 -1736.703)",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27174",
    "data-name": "Group 27174",
    transform: "translate(18.501 228.436)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27173",
    "data-name": "Group 27173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27172",
    "data-name": "Group 27172",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52931",
    "data-name": "Path 52931",
    d: "M245.786,2557.821a.711.711,0,0,1-.531,1.3c-2.973-.712-6.772-1.413-9.256-1.1-2.393.3-3.809-.3-7.572.3-3.509.565-3.544,1.977-8.648.889-3.945-.845-9.307,1.6-12.935,5.657a10.326,10.326,0,0,1,6.108-5.953c1.31-.518,2.776-2.3,5.872-3.089,2.906-.733,3.431.768,4.977.638,2.237-.187,2.17-1.663,4.012-2.262,2.328-.754,4.185.624,5.245.7,3.022.211,3.653-2.335,8.3.514l-.011-.056c1.548.769,3.1,1.651,4.438,2.458",
    transform: "translate(-206.844 -2553.982)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27177",
    "data-name": "Group 27177",
    transform: "translate(17.719 172.651)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27176",
    "data-name": "Group 27176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27175",
    "data-name": "Group 27175",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52932",
    "data-name": "Path 52932",
    d: "M257.587,1993.052c.669,5.555,1.208,10.378.416,13.312-3.97,14.682-42.87,13.615-52.874,8.067-4-2.219-6.809-7.366-7.028-12.378,3.59,6.009,13.308,10.409,31.714,9.7,27.212-1.05,25.444-20.6,20.434-28.269s.123-13.449-2.582-19.952-3.392-6.784-8.282-8.482-1.106-9.278-8.278-10.74-5.615-7.757-5.654-10.7a5.328,5.328,0,0,0-1.148-3.308c.934.148,1.758.268,2.159.983,1.353,2.406-.623,7.595,3.139,7.743,3.463.137,5.58-.793,8.4,6.14s8.933-1.152,10.909,5.58c1.423,4.854,10.511,3.445,9.6,6.246-.955,2.917-4.477.479-4.16,2.638.264,1.821,3.892,4.583,4.241,6.623.564,3.286-2.959,2.744-2.73,4.586.356,2.906,3.716,5.59,2.8,8.067-.479,1.307-2.191,2.927-2.11,4.308.162,2.8,2.431,2.424,2.424,5.763,0,1.5-1.557,2.663-1.388,4.079",
    transform: "translate(-198.101 -1930.297)",
    fill: "#1d1c22"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52934",
    "data-name": "Path 52934",
    d: "M1670.276,1825.918a25.515,25.515,0,0,0,3.782-13.105c.041-2.579,2.8-2.5,2.6-6.7-.1-2.1-2.948-3.312-3.11-6.34-.081-1.515,3.029-2.787,2.239-6.179-.487-2.092-3.841-3.985-4.189-6.586-.283-2.111.613-4.373,0-6.391-.862-2.827-4.092-3.9-4.589-6.414-.315-1.593.59-3.292-1.214-6.092-1.485-2.305-4.441-2-6.079-3.214-5.816-4.308-10.237-3.53-12.216-.824-1.281,1.752-.894,3.31-1.669,4.4-.911,1.282-3.365,1.427-4.2,3.392-.661,1.555.37,3.751-.3,4.954-1.057,1.909-3.473,1.952-3.473,5.681",
    transform: "translate(-1491.362 -1604.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52935",
    "data-name": "Path 52935",
    d: "M1636.758,1850.609c-8.937,4.956-43.68,5.907-47.224-7.207,0,0-4.287-6.482-2.244-22.185l4.019-38.717c0-.225.01-.44.028-.641.261-3.1,2.452-3.244,3.445-5.037.666-1.2-.363-3.4.3-4.956.835-1.965,3.29-2.11,4.2-3.392.775-1.092.387-2.649,1.67-4.4,1.976-2.709,6.4-3.484,12.213.824,1.638,1.212,4.6.909,6.08,3.213,1.8,2.8.9,4.5,1.215,6.09.5,2.512,3.727,3.589,4.586,6.415a4.9,4.9,0,0,1,.162.743c.254,1.821-.405,3.794-.159,5.65.349,2.6,3.7,4.495,4.188,6.584.789,3.392-2.318,4.664-2.24,6.182.12,2.237,1.708,3.484,2.568,4.829a3.049,3.049,0,0,1,.542,1.511c.2,4.2-2.554,4.125-2.6,6.7a24.626,24.626,0,0,1-3.681,12.688c-.021.035-.042.063-.06.092-.07.109-.113.162-.113.162s2.353.028,3.73.162c7.563.743,11.956,3.762,14.041,7.489,3.459,6.172.592,14.277-4.671,17.2",
    transform: "translate(-1444.816 -1604.269)",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27180",
    "data-name": "Group 27180",
    transform: "translate(159.624 200.335)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27179",
    "data-name": "Group 27179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27178",
    "data-name": "Group 27178",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52936",
    "data-name": "Path 52936",
    d: "M1807.717,2248.028a24.622,24.622,0,0,1-3.681,12.688c-.021.035-.042.063-.06.092l-6.086-.08a9.619,9.619,0,0,0-5.736,1.8,9.624,9.624,0,0,1-3.7,1.614l-3.705.751a12.928,12.928,0,0,1,2.867-9.87c5.492-6.354,7.754-.161,20.3-10.93a6.241,6.241,0,0,0,1.853-4.283,3.047,3.047,0,0,1,.542,1.511c.2,4.2-2.554,4.125-2.6,6.7",
    transform: "translate(-1784.646 -2239.813)",
    fill: "#1d1c22"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27183",
    "data-name": "Group 27183",
    transform: "translate(156.295 221.238)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27182",
    "data-name": "Group 27182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27181",
    "data-name": "Group 27181",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52937",
    "data-name": "Path 52937",
    d: "M1787.745,2481.419c-4.192-3.22-12.17-4.83-16.6-4.816-2.142.007-5.559,2.369-8.025,1.724a10.388,10.388,0,0,0-9.933,3.015,15.8,15.8,0,0,1-5.411,3.9s-1.025-1.385.43-3.607,4.234-4.572,7.179-5.016,2.79-3.177,5.058-2.885a32.8,32.8,0,0,0,9.7-.222c-.109.169-.173.253-.173.253s2.353.028,3.73.162c7.563.743,11.956,3.762,14.041,7.489",
    transform: "translate(-1747.428 -2473.515)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27186",
    "data-name": "Group 27186",
    transform: "translate(146.522 157.585)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27185",
    "data-name": "Group 27185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27184",
    "data-name": "Group 27184",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52938",
    "data-name": "Path 52938",
    d: "M1672.03,1781.359c-.895-1.2-2.466-1.275-5.006-2.251-3.716-1.427-1.508-5.52-2.667-8.211s-4.417-.754-7.271-3.526-5.869.106-6.38,1.589c-.771,2.226-4.847,1.751-5.143,4.981s-1.927,4.791-4.28,5.291a5.29,5.29,0,0,0-3.125,2.628c.261-3.1,2.452-3.244,3.445-5.037.666-1.2-.363-3.4.3-4.956.835-1.966,3.29-2.11,4.2-3.392.775-1.092.387-2.649,1.67-4.4,1.976-2.709,6.4-3.484,12.213.824,1.638,1.212,4.6.909,6.08,3.213,1.8,2.8.9,4.5,1.215,6.09.5,2.512,3.727,3.589,4.586,6.415a4.932,4.932,0,0,1,.162.743",
    transform: "translate(-1638.16 -1761.854)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27189",
    "data-name": "Group 27189",
    transform: "translate(141.921 220.886)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27188",
    "data-name": "Group 27188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27187",
    "data-name": "Group 27187",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52939",
    "data-name": "Path 52939",
    d: "M1636.745,2495.03c-8.937,4.956-43.68,5.907-47.224-7.207,0,0-3.565-5.39-2.646-18.247.585,7.147,2.646,10.265,2.646,10.265,3.544,13.115,38.287,12.164,47.224,7.208a12.422,12.422,0,0,0,5.555-7.221c1.948,5.819-.842,12.589-5.555,15.2",
    transform: "translate(-1586.724 -2469.576)",
    fill: "#1d1c22"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52942",
    "data-name": "Path 52942",
    d: "M461.991,2640.1a21.653,21.653,0,0,0-4.153,5.63,9.957,9.957,0,0,0-.926,3.187,12.343,12.343,0,0,0,.044,3.338,24.685,24.685,0,0,0,1.857,6.63,11.522,11.522,0,0,0,1.691,2.729,3.735,3.735,0,0,0,2.2,1.331l.02,0a1.409,1.409,0,0,1-.333,2.8,5.525,5.525,0,0,1-2.3-.778,7.6,7.6,0,0,1-1.717-1.458,12.841,12.841,0,0,1-2.129-3.491,21.781,21.781,0,0,1-1.184-3.707,24.269,24.269,0,0,1-.579-3.808,13.842,13.842,0,0,1,.214-3.963,12.075,12.075,0,0,1,1.41-3.722,11.533,11.533,0,0,1,2.475-3.006,9.656,9.656,0,0,1,3.3-1.917.12.12,0,0,1,.122.2Z",
    transform: "translate(-413.785 -2405.661)",
    fill: "#1d1c22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52943",
    "data-name": "Path 52943",
    d: "M279.927,2647.341a19.157,19.157,0,0,0-3.1,5.213,12.478,12.478,0,0,0-.425,1.4,12.081,12.081,0,0,0-.212,1.439,12.682,12.682,0,0,0-.051,1.451c0,.486.072.993.1,1.486.049.495.155.979.225,1.467.11.479.217.958.349,1.428.164.46.281.935.488,1.375l.278.671.324.648a14.609,14.609,0,0,0,1.583,2.4l.469.54c.166.168.324.348.5.508s.339.325.514.473.374.307.481.386l.115.085a1.406,1.406,0,0,1-1.626,2.294l-.231-.156c-.07-.048-.135-.095-.194-.141-.123-.093-.25-.187-.363-.283-.237-.189-.459-.388-.675-.593s-.416-.42-.624-.63-.388-.441-.579-.665a15.4,15.4,0,0,1-1.873-2.955,16.625,16.625,0,0,1-1.637-6.666,13.639,13.639,0,0,1,1.269-6.732,9.974,9.974,0,0,1,1.966-2.8,7.692,7.692,0,0,1,2.811-1.839.12.12,0,0,1,.133.189Z",
    transform: "translate(-249.251 -2412.26)",
    fill: "#1d1c22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52944",
    "data-name": "Path 52944",
    d: "M1879.259,2557.1a8.9,8.9,0,0,1,3.126,1.422,10.1,10.1,0,0,1,4.028,5.791c.064.3.156.6.193.912l.087.929a11.86,11.86,0,0,1-.038,1.807,18.807,18.807,0,0,1-.635,3.451,16.692,16.692,0,0,1-1.289,3.313,10.54,10.54,0,0,1-2.251,3.008,7.032,7.032,0,0,1-1.695,1.142,6,6,0,0,1-2.055.555,1.409,1.409,0,0,1-.3-2.8l.03,0a3.869,3.869,0,0,0,2.1-1.028,8.523,8.523,0,0,0,1.693-2.205,18.008,18.008,0,0,0,1.925-5.724,8.736,8.736,0,0,0,.029-2.885,8.122,8.122,0,0,0-.975-2.72,22.648,22.648,0,0,0-4.082-4.752l-.006-.006a.12.12,0,0,1,.108-.206",
    transform: "translate(-1709.298 -2330.279)",
    fill: "#1d1c22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52945",
    "data-name": "Path 52945",
    d: "M2045.577,2563.308a6.844,6.844,0,0,1,2.679,1.375,8.457,8.457,0,0,1,2,2.343,9.793,9.793,0,0,1,1.148,2.944c.049.261.12.522.148.786l.069.8c.04.53,0,1.033,0,1.554-.027.516-.1,1.033-.16,1.552-.121.508-.2,1.029-.364,1.53a13.019,13.019,0,0,1-1.248,2.9,13.66,13.66,0,0,1-1.919,2.513,12.687,12.687,0,0,1-1.176,1.066c-.2.169-.422.327-.645.479s-.432.289-.744.462a1.407,1.407,0,0,1-1.442-2.415l.1-.061c.1-.063.3-.195.45-.309s.325-.249.486-.382a12.026,12.026,0,0,0,.925-.848,12.831,12.831,0,0,0,1.568-1.964,11.806,11.806,0,0,0,1.694-4.745c.029-.426.1-.87.1-1.286l0-.625c0-.209-.038-.412-.054-.62a7.681,7.681,0,0,0-.667-2.418,18.865,18.865,0,0,0-3.06-4.423l-.007-.008a.121.121,0,0,1,.01-.171.123.123,0,0,1,.108-.027",
    transform: "translate(-1860.522 -2335.927)",
    fill: "#1d1c22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52946",
    "data-name": "Path 52946",
    d: "M1168.838,116.6c-.007,0-.011,0-.007.007.116.4,3.625,12.554-.761,20.082-3.97,6.82-6.781,2.519-6.781,2.519a84.415,84.415,0,0,1-6.714,8.338,32.821,32.821,0,0,1-7.426,6.313,7.287,7.287,0,0,1-4.061,1.124,8.6,8.6,0,0,1-.941-.137,5.88,5.88,0,0,1-.7-.187c-6.394-2.184,2.888-13.861,3.1-30.358.342-26.617-10.614-45.934-22.122-57.045l-.039-.039s5.992.313,12,1.282c3.966.638,7.947,1.56,10.219,2.871,5.3,3.051,2.656,6.094,2.526,6.238,0,0,0,0,0,.007.38.078,14.492,3.061,18.793,10.328,2.145,3.618-2.364,4.231-2.607,4.262,0,0-.007,0,0,.007.268.282,8.662,9.162,10.3,16.651,2.346,10.765-4.491,7.866-4.787,7.736",
    transform: "translate(-1022.003 -61.207)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52947",
    "data-name": "Path 52947",
    d: "M90.085,67.219a.373.373,0,0,1-.039.035C78.535,78.368,67.58,97.686,67.921,124.3c.215,16.648,9.669,28.385,2.927,30.414a5.772,5.772,0,0,1-.733.173c-.225.039-.469.07-.726.1a7.426,7.426,0,0,1-4.181-1.191,34.2,34.2,0,0,1-7.626-6.591,84.453,84.453,0,0,1-6.393-7.993s-2.815,4.3-6.785-2.519c-4.386-7.528-.877-19.681-.757-20.082a.008.008,0,0,0-.007-.007c-.3.13-7.133,3.03-4.787-7.735,1.631-7.489,10.025-16.37,10.293-16.651,0,0,0-.007,0-.007-.243-.032-4.748-.645-2.607-4.262,4.3-7.267,18.413-10.251,18.793-10.328,0,0,0,0,0-.007-.127-.144-2.772-3.188,2.526-6.238,2.205-1.272,6.009-2.177,9.856-2.811,6.133-1.018,12.371-1.342,12.371-1.342",
    transform: "translate(-34.932 -61.207)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27192",
    "data-name": "Group 27192",
    transform: "translate(3.432 6.013)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27191",
    "data-name": "Group 27191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27190",
    "data-name": "Group 27190",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52948",
    "data-name": "Path 52948",
    d: "M90.088,67.219c-.655.631-1.31,1.289-1.959,1.976-4.914,1.1-13.319,3.149-17.842,5.147-5.594,2.466,1.159,4.509,1.155,4.509-.38.077-15.661,5.027-19.977,8.683-3.209,2.72,4.414,4.706,4.657,4.738,0,.007-5.951,3.229-8.83,6.354s-6.588,9.519-8.371,16.944c-.624-1.18-.824-3.23-.067-6.7,1.631-7.489,10.025-16.37,10.293-16.651,0,0,0-.007,0-.007-.243-.032-4.748-.645-2.607-4.262,4.3-7.267,18.413-10.251,18.793-10.328,0,0,0,0,0-.007-.127-.144-2.772-3.188,2.526-6.238,5.717-3.294,22.227-4.153,22.227-4.153",
    transform: "translate(-38.367 -67.219)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27195",
    "data-name": "Group 27195",
    transform: "translate(100.706 6.013)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27194",
    "data-name": "Group 27194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27193",
    "data-name": "Group 27193",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52949",
    "data-name": "Path 52949",
    d: "M1125.932,67.219c.655.631,1.31,1.289,1.958,1.976,4.914,1.1,13.319,3.149,17.842,5.147,5.594,2.466-1.159,4.509-1.155,4.509.38.077,15.661,5.027,19.976,8.683,3.209,2.72-4.414,4.706-4.657,4.738,0,.007,5.951,3.229,8.83,6.354s6.588,9.519,8.371,16.944c.624-1.18.824-3.23.067-6.7-1.631-7.489-10.025-16.37-10.293-16.651,0,0,0-.007,0-.007.243-.032,4.748-.645,2.607-4.262-4.3-7.267-18.412-10.251-18.793-10.328,0,0,0,0,0-.007.127-.144,2.772-3.188-2.526-6.238-5.717-3.294-22.227-4.153-22.227-4.153",
    transform: "translate(-1125.932 -67.219)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27198",
    "data-name": "Group 27198",
    transform: "translate(19.221 6.047)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27197",
    "data-name": "Group 27197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27196",
    "data-name": "Group 27196",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52950",
    "data-name": "Path 52950",
    d: "M228.667,124.661c.215,16.648,9.669,28.385,2.927,30.414-.521-.254-1-.493-1.423-.708a3.846,3.846,0,0,0-3-.215,33.629,33.629,0,0,1-7.433-6.591,104.052,104.052,0,0,1,.321-11.67,4.11,4.11,0,0,0-2.667-4.15c-1.469-.56-2.836-2-2.409-5.513.514-4.21,3.847-10.3,6.186-14.147a4.213,4.213,0,0,0-.7-5.143.946.946,0,0,1-.116-.127c-2.934-3.66,2.638-9.7,6.851-13.449a4.082,4.082,0,0,0,.581-5.485A3.225,3.225,0,0,1,227.3,84.7c.951-2.814,6.274-7.028,9.814-9.581a4.15,4.15,0,0,0,1.511-4.238,2.141,2.141,0,0,1,.722-1.966c4.844-.824,9.754-1.194,11.441-1.307-11.512,11.114-22.467,30.432-22.125,57.048",
    transform: "translate(-214.899 -67.613)",
    fill: "#1d1c22"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27201",
    "data-name": "Group 27201",
    transform: "translate(100.429 6.051)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27200",
    "data-name": "Group 27200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27199",
    "data-name": "Group 27199",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52951",
    "data-name": "Path 52951",
    d: "M1155.931,131.778a4.1,4.1,0,0,0-2.67,4.15,101.04,101.04,0,0,1,.3,12.016,32.194,32.194,0,0,1-7.235,6.313c-.021-.007-.042-.018-.063-.025a3.845,3.845,0,0,0-3.121.173c-.387.2-.828.416-1.3.652-6.393-2.184,2.889-13.861,3.1-30.358.342-26.617-10.614-45.934-22.122-57.045,1.649.109,6.358.461,11.078,1.243a2.2,2.2,0,0,1,.782,2.026,4.145,4.145,0,0,0,1.515,4.238c3.533,2.554,8.863,6.767,9.81,9.581a3.234,3.234,0,0,1-.479,3.174,4.086,4.086,0,0,0,.581,5.485c4.213,3.744,9.786,9.789,6.851,13.449-.035.042-.074.085-.113.127a4.214,4.214,0,0,0-.7,5.143c2.339,3.843,5.675,9.937,6.186,14.147.43,3.516-.937,4.953-2.406,5.513",
    transform: "translate(-1122.826 -67.653)",
    fill: "#1d1c22"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52952",
    "data-name": "Path 52952",
    d: "M567.079,825.61a1.965,1.965,0,0,1-2.156.021,2.771,2.771,0,0,0-3.98.983c-.028.053-.056.1-.085.155-1.508,2.815-3.618,5.978-5.7,6.5a2.15,2.15,0,0,1-2.691-1,2.732,2.732,0,0,0-3.822-.965,46.875,46.875,0,0,1-9.374,4.421,2.782,2.782,0,0,1-1.821,0,46.735,46.735,0,0,1-9.37-4.421,2.736,2.736,0,0,0-3.826.965,2.15,2.15,0,0,1-2.691,1c-2.085-.521-4.2-3.692-5.7-6.51-.028-.049-.053-.1-.078-.144a2.776,2.776,0,0,0-3.984-.983,1.965,1.965,0,0,1-2.156-.021c-3.973-2.18-3.635-12.163-3.635-12.163l32.355-15.82,32.351,15.82s.338,9.983-3.635,12.163",
    transform: "translate(-460.743 -726.285)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52956",
    "data-name": "Path 52956",
    d: "M330.5,17.456c5.016-3.239,8.141-1.211,9.656.476a3.538,3.538,0,0,0,3.068,1.141c4.077-.5,11.022.451,15.728,3.864,1.157.839,1.411,1.619,1.276,2.267a3.608,3.608,0,0,0,1.371,3.744c3.206,2.257,8.035,5.977,8.9,8.463a2.8,2.8,0,0,1-.434,2.806,3.541,3.541,0,0,0,.528,4.844c3.818,3.31,8.872,8.649,6.211,11.881a1.508,1.508,0,0,1-.1.113,3.65,3.65,0,0,0-.634,4.543c2.12,3.4,5.143,8.779,5.608,12.5.388,3.106-.851,4.376-2.182,4.871a3.631,3.631,0,0,0-2.42,3.666c.372,4.767.77,13.076-.7,15.667-1.056,1.857-3.918,1.146-5.639.5a3.565,3.565,0,0,0-2.829.153,39.439,39.439,0,0,1-7.28,2.954c-14,2.817-25.242-3.754-29.722-6.97a3.593,3.593,0,0,0-4.2,0c-4.48,3.215-15.725,9.787-29.722,6.97a39.441,39.441,0,0,1-7.28-2.954,3.565,3.565,0,0,0-2.829-.153c-1.721.644-4.583,1.354-5.639-.5-1.473-2.591-1.076-10.9-.7-15.667a3.631,3.631,0,0,0-2.42-3.666c-1.331-.495-2.57-1.765-2.182-4.871.465-3.718,3.488-9.1,5.608-12.5a3.65,3.65,0,0,0-.634-4.543,1.523,1.523,0,0,1-.1-.113c-2.661-3.232,2.393-8.571,6.211-11.881a3.541,3.541,0,0,0,.528-4.844,2.8,2.8,0,0,1-.434-2.806c.86-2.486,5.689-6.206,8.9-8.463a3.608,3.608,0,0,0,1.371-3.744c-.135-.648.119-1.428,1.276-2.267,4.476-3.246,10.976-4.268,15.109-3.927a3.582,3.582,0,0,0,3.318-1.618c1.056-1.636,3.624-3.115,9.84.22a3.549,3.549,0,0,0,3.6-.155",
    transform: "translate(-251.173 -14.212)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27204",
    "data-name": "Group 27204",
    transform: "translate(35.727 1.395)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27203",
    "data-name": "Group 27203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27202",
    "data-name": "Group 27202",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52957",
    "data-name": "Path 52957",
    d: "M482.168,40.912c-1.747-2.318-5.428-5.122-8.035-6.957a11.712,11.712,0,0,1-3.452-5A3.876,3.876,0,0,0,469,26.45c-4.706-3.41-9.163-2.873-13.239-2.369a3.542,3.542,0,0,1-3.068-1.141c-1.515-1.687-4.639-3.716-9.655-.476a3.548,3.548,0,0,1-3.6.155c-6.217-3.336-8.785-1.856-9.842-.222a3.557,3.557,0,0,1-3.315,1.62c-4.088-.372-9.854-.234-12.816,1.947-1.153.849-.929,1.824-.707,2.793.326,1.424-3.041,4.355-4.235,5.2-2.607,1.835-6.288,4.639-8.035,6.957a3.241,3.241,0,0,0-.426-.7,2.792,2.792,0,0,1-.433-2.8c.86-2.487,5.689-6.207,8.895-8.465a3.6,3.6,0,0,0,1.37-3.744c-.134-.645.12-1.427,1.279-2.265,4.474-3.244,10.973-4.269,15.108-3.928a3.576,3.576,0,0,0,3.315-1.617c1.057-1.638,3.625-3.118,9.842.218a3.548,3.548,0,0,0,3.6-.155c5.016-3.237,8.141-1.212,9.655.476a3.542,3.542,0,0,0,3.068,1.141c4.076-.5,11.022.451,15.728,3.864,1.155.838,1.409,1.62,1.275,2.265a3.607,3.607,0,0,0,1.37,3.744c3.206,2.258,8.035,5.978,8.895,8.465a2.792,2.792,0,0,1-.433,2.8,3.237,3.237,0,0,0-.426.7",
    transform: "translate(-399.437 -15.6)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27207",
    "data-name": "Group 27207",
    transform: "translate(45.258 71.342)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27206",
    "data-name": "Group 27206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27205",
    "data-name": "Group 27205",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52959",
    "data-name": "Path 52959",
    d: "M567.079,825.61a1.965,1.965,0,0,1-2.156.021,2.771,2.771,0,0,0-3.98.983c-.028.053-.056.1-.085.155-8.63-1.465-21.791-6.982-22.53-14.665-.736,7.662-13.83,13.167-22.467,14.654-.028-.049-.053-.1-.078-.144a2.776,2.776,0,0,0-3.984-.983,1.965,1.965,0,0,1-2.156-.021c-3.973-2.18-3.635-12.163-3.635-12.163l32.355-15.82,32.351,15.82s.338,9.983-3.635,12.163",
    transform: "translate(-506.001 -797.627)",
    fill: "#1d1c22"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27210",
    "data-name": "Group 27210",
    transform: "translate(114.086 78.412)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27209",
    "data-name": "Group 27209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27208",
    "data-name": "Group 27208",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52960",
    "data-name": "Path 52960",
    d: "M1276.844,876.67a14.807,14.807,0,0,1,1.427,7.771,20.263,20.263,0,0,0-2.755-7.394,5.784,5.784,0,0,0,1.328-.377",
    transform: "translate(-1275.516 -876.67)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27213",
    "data-name": "Group 27213",
    transform: "translate(77.581 72.744)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27212",
    "data-name": "Group 27212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27211",
    "data-name": "Group 27211",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52961",
    "data-name": "Path 52961",
    d: "M867.424,813.591v.028c-.018-.1-.028-.194-.039-.289,0-.011,0-.018,0-.028.011.1.021.194.035.289",
    transform: "translate(-867.385 -813.302)",
    fill: "#1d1c22"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27216",
    "data-name": "Group 27216",
    transform: "translate(77.543 72.744)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27215",
    "data-name": "Group 27215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27214",
    "data-name": "Group 27214",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52962",
    "data-name": "Path 52962",
    d: "M866.991,813.33c-.011.1-.021.194-.039.289v-.028c.014-.1.025-.194.035-.289,0,.01,0,.018,0,.028",
    transform: "translate(-866.952 -813.302)",
    fill: "#1d1c22"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52963",
    "data-name": "Path 52963",
    d: "M525.163,214.851a35.651,35.651,0,0,0-4.379-2.365,13.993,13.993,0,0,0-4.371-1.238,7.56,7.56,0,0,0-2.055.1,3.532,3.532,0,0,0-.486.112,3.377,3.377,0,0,0-.474.152,4.1,4.1,0,0,0-.467.184l-.233.1a1.346,1.346,0,0,0-.144.081,6.5,6.5,0,0,0-1.932,3.164l-.441,1.368-1.246-.256c-.876-.18-1.8-.363-2.678-.495-.432-.07-.879-.113-1.209-.133a1.86,1.86,0,0,0-.468.051,3.094,3.094,0,0,0-.517.133,3.7,3.7,0,0,0-1.776,1.473,8.627,8.627,0,0,0-1.112,2.548,6.323,6.323,0,0,1,0-3.025,5.163,5.163,0,0,1,.265-.768l.173-.381.224-.363a5.293,5.293,0,0,1,.54-.689,5.866,5.866,0,0,1,.69-.575,4.39,4.39,0,0,1,.79-.439,4.275,4.275,0,0,1,.914-.3,9.8,9.8,0,0,1,1.647-.137,23.938,23.938,0,0,1,3,.172l-1.686,1.113c.063-.289.118-.489.185-.728s.145-.452.227-.676a10.312,10.312,0,0,1,.59-1.333,7.632,7.632,0,0,1,.873-1.3,4.849,4.849,0,0,1,1.355-1.154c.134-.072.3-.169.41-.213l.344-.144a5.4,5.4,0,0,1,.708-.255,6.056,6.056,0,0,1,.734-.188,6.278,6.278,0,0,1,.745-.125,8.907,8.907,0,0,1,2.946.146,11.836,11.836,0,0,1,4.905,2.437,14.071,14.071,0,0,1,3.4,3.943",
    transform: "translate(-456.183 -189.636)",
    fill: "#1d1c22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52964",
    "data-name": "Path 52964",
    d: "M965.393,214.851a14.07,14.07,0,0,1,3.4-3.943,11.836,11.836,0,0,1,4.905-2.437,8.907,8.907,0,0,1,2.946-.146,6.281,6.281,0,0,1,.746.125,6.052,6.052,0,0,1,.734.188,5.4,5.4,0,0,1,.708.255l.344.144c.111.045.276.141.41.213a4.849,4.849,0,0,1,1.355,1.154,7.636,7.636,0,0,1,.873,1.3,10.325,10.325,0,0,1,.59,1.333c.082.224.158.448.227.676s.122.439.185.728l-1.687-1.113a23.94,23.94,0,0,1,3-.172,9.8,9.8,0,0,1,1.647.137,4.277,4.277,0,0,1,.914.3,4.39,4.39,0,0,1,.79.439,5.862,5.862,0,0,1,.69.575,5.291,5.291,0,0,1,.54.689l.224.363.173.381a5.166,5.166,0,0,1,.265.768,6.323,6.323,0,0,1,0,3.025,8.625,8.625,0,0,0-1.112-2.548,3.7,3.7,0,0,0-1.776-1.473,3.094,3.094,0,0,0-.517-.133,1.859,1.859,0,0,0-.468-.051c-.331.019-.778.062-1.209.133-.873.132-1.8.315-2.678.495l-1.245.256-.441-1.368A6.5,6.5,0,0,0,978,211.977a1.35,1.35,0,0,0-.144-.081l-.233-.1a4.1,4.1,0,0,0-.467-.184,3.383,3.383,0,0,0-.474-.152,3.53,3.53,0,0,0-.486-.112,7.56,7.56,0,0,0-2.055-.1,14,14,0,0,0-4.371,1.238,35.659,35.659,0,0,0-4.379,2.365",
    transform: "translate(-879.046 -189.636)",
    fill: "#1d1c22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52965",
    "data-name": "Path 52965",
    d: "M760.113,901.757a74.434,74.434,0,0,1-2.843,16.264c-1.73,5.379-4.474,10.018-8.8,10.018s-7.059-4.622-8.789-9.99a74.256,74.256,0,0,1-2.853-16.292Z",
    transform: "translate(-670.925 -821.101)",
    fill: "#f45642"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27219",
    "data-name": "Group 27219",
    transform: "translate(65.904 80.656)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27218",
    "data-name": "Group 27218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27217",
    "data-name": "Group 27217",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52966",
    "data-name": "Path 52966",
    d: "M760.113,901.757a74.434,74.434,0,0,1-2.843,16.264c-1.73,5.379-4.474,10.018-8.8,10.018s-7.059-4.622-8.789-9.99a74.256,74.256,0,0,1-2.853-16.292h.144a57.677,57.677,0,0,0,2.709,12.893c1.73,4.815,4.474,8.961,8.789,8.961s7.07-4.16,8.8-8.986a57.827,57.827,0,0,0,2.7-12.868Z",
    transform: "translate(-736.829 -901.757)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52967",
    "data-name": "Path 52967",
    d: "M852.021,914.676l-.844-15.1a1.411,1.411,0,0,1,2.818-.157,1.456,1.456,0,0,1,0,.157l-.845,15.1a.565.565,0,0,1-1.129,0",
    transform: "translate(-775.042 -817.755)",
    fill: "#1d1c22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52968",
    "data-name": "Path 52968",
    d: "M734.128,915.078c-11.3,0-12.9-24.794-13.05-27.621a1.409,1.409,0,0,1,2.814-.145c.359,6.939,2.9,24.948,10.235,24.948s9.879-18.009,10.235-24.948a1.409,1.409,0,0,1,2.814.145c-.145,2.827-1.745,27.621-13.05,27.621",
    transform: "translate(-656.581 -806.731)",
    fill: "#1d1c22"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27222",
    "data-name": "Group 27222",
    transform: "translate(65.904 80.656)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27221",
    "data-name": "Group 27221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27220",
    "data-name": "Group 27220",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52969",
    "data-name": "Path 52969",
    d: "M760.113,901.757a74.434,74.434,0,0,1-2.843,16.264c-4.678-2.071-8.38-5.016-8.761-8.986-.384,3.991-4.118,6.943-8.828,9.014a74.256,74.256,0,0,1-2.853-16.292Z",
    transform: "translate(-736.829 -901.757)",
    fill: "#1d1c22"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52970",
    "data-name": "Path 52970",
    d: "M450.947,587s-11.095-.862-16.921,3.357c-4.289,3.1-1.211,4.947-1.211,4.947s-10.242,3.648-11.167,11.6c-.342,2.934,3.347,3.412,3.347,3.412s-5.928,9.137-.71,14.511c2.181,2.246,7.424,3.663,11.7,3.407,8.147-.49,24.677-6.389,25.511-15.025.83,8.636,17.358,14.535,25.5,15.025,4.283.256,9.522-1.16,11.7-3.407,5.218-5.373-.707-14.511-.707-14.511s3.69-.478,3.347-3.412c-.929-7.948-11.171-11.6-11.171-11.6s3.078-1.846-1.211-4.947C483.14,586.139,472.046,587,472.046,587",
    transform: "translate(-383.914 -534.432)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27225",
    "data-name": "Group 27225",
    transform: "translate(37.711 53.937)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27224",
    "data-name": "Group 27224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27223",
    "data-name": "Group 27223",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52971",
    "data-name": "Path 52971",
    d: "M501.06,623.18c-2.357-7.345-16.757-13.107-16.757-13.107s5.5-2.142,2.254-3.505c-6.633-2.779-45.335-2.5-49.538.151-4.47,2.829,2.261,3.554,2.261,3.554s-10.014,1.858-17.345,12.914a2.641,2.641,0,0,1-.289-1.624c.926-7.947,11.167-11.6,11.167-11.6s-3.079-1.846,1.212-4.946c5.826-4.22,27.431-.418,27.431-.418s21.685-3.8,27.511.418c4.287,3.1,1.208,4.946,1.208,4.946s10.244,3.649,11.174,11.6a2.608,2.608,0,0,1-.289,1.617",
    transform: "translate(-421.624 -603.031)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27228",
    "data-name": "Group 27228",
    transform: "translate(38.222 72.773)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27227",
    "data-name": "Group 27227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27226",
    "data-name": "Group 27226",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52972",
    "data-name": "Path 52972",
    d: "M503.906,831.236c-2.181,2.247-7.422,3.663-11.7,3.406-8.137-.49-24.644-6.372-25.507-15-.863,8.623-17.37,14.506-25.507,15-4.28.257-9.522-1.159-11.7-3.406-2.487-2.557-2.445-5.967-1.716-8.842a9.989,9.989,0,0,0,6.372,6.217c10.117,3.8,31.2-6.14,32.513-14.707.018-.1.028-.194.039-.289.01.1.021.194.039.289,1.31,8.567,22.4,18.511,32.513,14.707a9.989,9.989,0,0,0,6.372-6.217c.729,2.874.771,6.284-1.716,8.842",
    transform: "translate(-427.338 -813.616)",
    fill: "#1d1c22"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52974",
    "data-name": "Path 52974",
    d: "M755.7,692.718c0,6.019-7.174,10.644-10.525,12.476a3.511,3.511,0,0,1-3.373,0c-3.35-1.832-10.525-6.457-10.525-12.476,0-7.853,24.422-7.853,24.422,0",
    transform: "translate(-665.872 -625.397)",
    fill: "#1d1c22"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27231",
    "data-name": "Group 27231",
    transform: "translate(70.811 64.061)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27230",
    "data-name": "Group 27230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27229",
    "data-name": "Group 27229",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52975",
    "data-name": "Path 52975",
    d: "M805.152,717.565c0,1.378-3.955,2.437-5.8,2.856a4.423,4.423,0,0,1-1.86,0c-1.847-.419-5.8-1.478-5.8-2.856,0-1.8,13.464-1.8,13.464,0",
    transform: "translate(-791.688 -716.217)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52978",
    "data-name": "Path 52978",
    d: "M1027.527,1559.781c-10,5.548-48.907,6.615-52.874-8.067a56.174,56.174,0,0,1-1.286-13.354c0-1.021-2.209-1.169-2.061-3.445.144-2.226,2.209-4.2,2.328-6.474.106-2.019-2.018-2.966-2.557-4.861-.8-2.772,3.192-5.143,3.512-8.239.247-2.35-1.966-1.4-2.825-3.551-1.212-3.029,2.786-2.5,3.431-4.446.743-2.23-2.621-3.554-1.483-5.611,1.254-2.261,8.218-3.621,7.661-7.714-1.05-7.753,6.337-5.946,8.158-8.563,1.86-2.663-.416-8.746,5.333-9.046.5-.025.972-.067,1.413-.13,4.558-.613,6.01-3.1,6.341-8.916l14.675-35.62c.349,5.978,4.685,7.968,4.738,12.924.046,4.283-2.934,4.28-3.3,6.017-.673,3.209,7.228,5.854,7.228,12.963,0,3.153-4.608,1.733-3.9,4.865.5,2.2,7.531,9.109.712,14.2-2.018,1.508,5.6,7.535,4.96,11.012-.592,3.23-3.769,3.121-4.96,5.143-1.363,2.307,4.273,6.732,2.6,10.769-1.229,2.963-3.854,2.075-4.9,4.981-.877,2.424,1.4,4.738-4.15,8.563-3.336,2.3-.673,8.3-.645,8.937l.859.289c1.923.645,6.5,2.205,7.595,2.755a16.281,16.281,0,0,1,8.648,9.5,13.953,13.953,0,0,1,.652,3.406c.31,4.875-1.958,9.529-5.9,11.716",
    transform: "translate(-884.126 -1303.683)",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27234",
    "data-name": "Group 27234",
    transform: "translate(87.09 173.282)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27233",
    "data-name": "Group 27233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27232",
    "data-name": "Group 27232",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52979",
    "data-name": "Path 52979",
    d: "M1030.245,2020.85c-10,5.548-48.907,6.615-52.874-8.067a56.174,56.174,0,0,1-1.286-13.354c0-1.021-2.209-1.169-2.061-3.445.144-2.226,2.209-4.2,2.328-6.474.106-2.018-2.018-2.966-2.557-4.861-.8-2.772,3.191-5.143,3.512-8.239.247-2.35-1.966-1.4-2.825-3.551-1.212-3.03,2.786-2.5,3.431-4.445.743-2.23-2.621-3.554-1.483-5.612,1.254-2.261,8.218-3.621,7.662-7.714-1.05-7.753,6.337-5.946,8.158-8.563,1.86-2.663-.416-8.747,5.333-9.046.5-.025.972-.067,1.413-.13a5.869,5.869,0,0,0-2.462,5.826c.645,6.179-1.664,8.912-6.463,12.075-4.53,2.985.889,9.047-4.767,14.62-6.9,6.8-1.531,14.379-2.422,19.79s-4.979,13.32,1.7,22.366c6.21,8.412,45.152,11.558,51.57-2.89.31,4.875-1.958,9.529-5.9,11.716",
    transform: "translate(-973.69 -1937.347)",
    fill: "#1d1c22"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52980",
    "data-name": "Path 52980",
    d: "M1299.961,2639.9a9.656,9.656,0,0,1,3.3,1.917,11.524,11.524,0,0,1,2.475,3.006,12.071,12.071,0,0,1,1.41,3.722,13.832,13.832,0,0,1,.214,3.962,24.272,24.272,0,0,1-.579,3.808,21.783,21.783,0,0,1-1.184,3.707,12.845,12.845,0,0,1-2.129,3.491,7.581,7.581,0,0,1-1.717,1.457,5.521,5.521,0,0,1-2.3.778,1.409,1.409,0,0,1-.336-2.8l.022,0a3.735,3.735,0,0,0,2.2-1.331,11.526,11.526,0,0,0,1.691-2.729,24.692,24.692,0,0,0,1.857-6.63,12.342,12.342,0,0,0,.044-3.338,9.966,9.966,0,0,0-.926-3.187,21.658,21.658,0,0,0-4.153-5.63l-.006-.007a.12.12,0,0,1,.122-.2",
    transform: "translate(-1181.81 -2406.608)",
    fill: "#1d1c22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52981",
    "data-name": "Path 52981",
    d: "M1493.439,2647.145a7.686,7.686,0,0,1,2.811,1.838,9.982,9.982,0,0,1,1.966,2.8,13.641,13.641,0,0,1,1.269,6.732,16.627,16.627,0,0,1-1.637,6.666,15.414,15.414,0,0,1-1.873,2.956c-.191.224-.382.447-.579.665s-.406.428-.624.63-.437.4-.674.593c-.113.1-.24.19-.363.284q-.09.07-.194.141l-.231.156a1.406,1.406,0,0,1-1.628-2.292l.118-.087c.107-.08.319-.241.481-.386s.343-.312.514-.473.329-.34.5-.508l.469-.54a14.572,14.572,0,0,0,1.583-2.4l.324-.647.277-.671c.207-.439.325-.915.488-1.375.132-.47.239-.949.349-1.428.07-.488.176-.972.225-1.466.031-.493.1-1,.1-1.486a12.65,12.65,0,0,0-.051-1.452,12.009,12.009,0,0,0-.212-1.439,12.408,12.408,0,0,0-.425-1.4,19.159,19.159,0,0,0-3.1-5.213l-.007-.009a.12.12,0,0,1,.133-.189",
    transform: "translate(-1357.747 -2413.208)",
    fill: "#1d1c22"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27237",
    "data-name": "Group 27237",
    transform: "translate(106.431 228.576)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27236",
    "data-name": "Group 27236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27235",
    "data-name": "Group 27235",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52982",
    "data-name": "Path 52982",
    d: "M1232.151,2567.953c-2.469-2-6.534-4.96-10.261-6.122-5.872-1.828-4.121-2.529-8.067-1.465a8.846,8.846,0,0,1-7.309-.768c-2.744-1.455-6.837,2.367-11.469,1.078a14.771,14.771,0,0,0-4.386-.528.71.71,0,0,1-.313-1.356,22.83,22.83,0,0,1,3.043-1.131c3.1-.9,6.89-.708,8.039-1.48,2.529-1.7,6.26.6,8.75.564a40.085,40.085,0,0,0,5.731-1.046c1.923.645,6.5,2.205,7.595,2.755a16.279,16.279,0,0,1,8.648,9.5",
    transform: "translate(-1189.929 -2555.554)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52985",
    "data-name": "Path 52985",
    d: "M574.488,386.447c-2.187,4.989-6.973,7.137-10.691,4.8s-4.96-8.279-2.773-13.268,6.973-7.137,10.691-4.8,4.959,8.279,2.773,13.268",
    transform: "translate(-509.861 -338.939)",
    fill: "#1d1c22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52986",
    "data-name": "Path 52986",
    d: "M661.227,432.141c-.364,1.876-1.559,3.165-2.67,2.879s-1.716-2.039-1.353-3.915,1.559-3.165,2.67-2.879,1.716,2.039,1.353,3.915",
    transform: "translate(-598.326 -389.888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52987",
    "data-name": "Path 52987",
    d: "M591.363,489.36c-.23.928-.862,1.55-1.411,1.388s-.808-1.045-.577-1.974.862-1.55,1.411-1.388.808,1.045.577,1.974",
    transform: "translate(-536.583 -443.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52988",
    "data-name": "Path 52988",
    d: "M1004.23,386.016c2.027,5.056,6.744,7.355,10.534,5.134s5.22-8.118,3.192-13.174-6.744-7.354-10.534-5.134-5.22,8.118-3.192,13.174",
    transform: "translate(-913.57 -338.723)",
    fill: "#1d1c22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52989",
    "data-name": "Path 52989",
    d: "M1034,430.924c.3,1.887,1.458,3.213,2.577,2.962s1.78-1.984,1.476-3.87-1.458-3.213-2.577-2.962-1.78,1.984-1.476,3.87",
    transform: "translate(-941.453 -388.829)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52990",
    "data-name": "Path 52990",
    d: "M1123.668,490.7c.2.935.812,1.577,1.366,1.433s.84-1.019.64-1.955-.812-1.577-1.366-1.433-.84,1.019-.64,1.955",
    transform: "translate(-1023.106 -445.013)",
    fill: "#fff"
  }))))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27297",
    "data-name": "Group 27297",
    transform: "translate(-4 -6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27284",
    "data-name": "Group 27284",
    transform: "translate(668.803 829.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27283",
    "data-name": "Group 27283",
    transform: "translate(-0.348 -0.115)",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53004",
    "data-name": "Path 53004",
    d: "M139.97,481.791c0,2.094-31.333,3.791-69.985,3.791S0,483.885,0,481.791,31.333,478,69.985,478s69.985,1.7,69.985,3.791",
    transform: "translate(0.287 -338.518)",
    fill: "#070e1c",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53005",
    "data-name": "Path 53005",
    d: "M109.089,109.089c-32.965,32.936-80.246,39.075-98.78,20.571-18.5-18.534-12.366-65.814,20.571-98.78C63.846-2.056,111.126-8.195,129.66,10.31c18.5,18.534,12.365,65.814-20.571,98.78",
    transform: "translate(0.287 0.095)",
    fill: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53006",
    "data-name": "Path 53006",
    d: "M142.884,29.974C142.341,49.59,129.79,80.022,104.9,104.9S49.59,142.341,29.974,142.884a33.882,33.882,0,0,1-14.711-8.273A33.882,33.882,0,0,1,6.99,119.9c.542-19.616,13.093-50.048,37.979-74.931S100.283,7.532,119.9,6.99a33.882,33.882,0,0,1,14.711,8.273,33.882,33.882,0,0,1,8.273,14.711",
    transform: "translate(-4.664 -4.857)",
    fill: "#25478c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53007",
    "data-name": "Path 53007",
    d: "M140.941,62.63a156.955,156.955,0,0,1-31.231,44.1,156.955,156.955,0,0,1-44.1,31.231c-12.25,5.7-24.063,8.923-33.835,9.291a30.053,30.053,0,0,1-7.127-5.22,29.6,29.6,0,0,1-4.4-5.675v0a75.892,75.892,0,0,1,7.456-34.272A146.028,146.028,0,0,1,38.328,83.167,163.764,163.764,0,0,1,71.381,46.755q1.7-1.4,3.438-2.727,4.811-3.714,9.83-7a145.041,145.041,0,0,1,18.389-10.279c12.25-5.7,24.063-8.923,33.835-9.291A30.053,30.053,0,0,1,144,22.68a29.6,29.6,0,0,1,4.4,5.675v0a75.892,75.892,0,0,1-7.456,34.272",
    transform: "translate(-14.053 -12.273)",
    fill: "#e23b50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53008",
    "data-name": "Path 53008",
    d: "M136.788,136.788c-26.14,26.14-57.909,36.73-67.44,27.2s1.059-41.3,27.2-67.44,57.909-36.73,67.44-27.2-1.059,41.3-27.2,67.44",
    transform: "translate(-46.395 -46.587)",
    fill: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53009",
    "data-name": "Path 53009",
    d: "M222.416,242.23c-2.711-2.711-.472-9.344,5-14.815s12.1-7.709,14.815-5Z",
    transform: "translate(-156.456 -156.648)",
    fill: "#3e4460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53010",
    "data-name": "Path 53010",
    d: "M235.253,255.067c2.711,2.711,9.344.472,14.815-5s7.709-12.1,5-14.815Z",
    transform: "translate(-166.365 -166.557)",
    fill: "#3e4460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53011",
    "data-name": "Path 53011",
    d: "M441.187,44.338A39.776,39.776,0,0,0,434.17,26.33a27.837,27.837,0,0,1,3.053,2.633,29.548,29.548,0,0,1,4.4,5.676Z",
    transform: "translate(-307.277 -18.557)",
    fill: "#c6243f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53012",
    "data-name": "Path 53012",
    d: "M36.089,442.445a30.212,30.212,0,0,1-7.126-5.222,27.837,27.837,0,0,1-2.633-3.053c4.962,3.716,11.358,6.095,18.647,7.11Z",
    transform: "translate(-18.365 -307.469)",
    fill: "#c6243f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53013",
    "data-name": "Path 53013",
    d: "M112.107,196.7a104.883,104.883,0,0,0,84.047-84.492l5.261-22.159c5.9,22.7-3.49,57.117-29.181,82.83-25.814,25.791-60.4,35.15-83.1,29.112Z",
    transform: "translate(-62.856 -63.696)",
    fill: "#c9d0d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53014",
    "data-name": "Path 53014",
    d: "M68.351,461.08a39.755,39.755,0,0,1-8.556-3.32l8.888-1.165a70.91,70.91,0,0,0,22.638-.806Z",
    transform: "translate(-42.071 -322.784)",
    fill: "#17345e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53015",
    "data-name": "Path 53015",
    d: "M456.134,87.255a70.035,70.035,0,0,0,.613-22.731l.435-9.7a38.814,38.814,0,0,1,4.213,10.27Z",
    transform: "translate(-322.836 -38.743)",
    fill: "#17345e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53016",
    "data-name": "Path 53016",
    d: "M100.627.013A142.9,142.9,0,0,0,37.914,33.656C18.19,51.858,5.884,73.713.72,94.143,2.248,73.827,12.335,49.962,31.391,30.888,52.372,9.925,79.15-.182,100.627.013",
    transform: "translate(-0.223 0.088)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53017",
    "data-name": "Path 53017",
    d: "M110.75,116.127A163.764,163.764,0,0,0,77.7,152.539a4.548,4.548,0,0,1-.816-.808,4.286,4.286,0,0,1-.554-4.794c13.877-22.582,27.527-33.371,33.817-31.3a.143.143,0,0,1,.044.029,3.5,3.5,0,0,1,.563.458",
    transform: "translate(-53.422 -81.646)",
    fill: "#4876c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53018",
    "data-name": "Path 53018",
    d: "M114.85,123.428c-12.344,9.014-23.226,25.495-25.915,29.72a4.6,4.6,0,0,1-6.675,1.184,163.764,163.764,0,0,1,33.053-36.413,3.657,3.657,0,0,1-.464,5.508",
    transform: "translate(-57.985 -83.439)",
    fill: "#fc637d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53019",
    "data-name": "Path 53019",
    d: "M214.338,81.129q-5.008,3.281-9.83,7a3.874,3.874,0,0,1-1.111-1.939c-.6-2.756,2.292-5.718,5.048-6.316a7.253,7.253,0,0,1,5.893,1.257",
    transform: "translate(-143.742 -56.373)",
    fill: "#4876c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53020",
    "data-name": "Path 53020",
    d: "M213.5,93.289a7.126,7.126,0,0,1-6.1-1.72q4.811-3.714,9.83-7a3.561,3.561,0,0,1,1.222,1.977c.595,2.753-2.2,6.144-4.954,6.742",
    transform: "translate(-146.634 -59.814)",
    fill: "#fc637d"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30411",
    "data-name": "Group 30411",
    transform: "translate(1112.234 398.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27144-2",
    "data-name": "Group 27144",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52906-2",
    "data-name": "Path 52906",
    d: "M25.092,11.3a22.671,22.671,0,0,0-.32-2.824,26.73,26.73,0,0,0-.753-3.14,6.819,6.819,0,0,0-1.41-2.611,6.252,6.252,0,0,0-2.186-1.561A10.91,10.91,0,0,0,18.254.534,20.69,20.69,0,0,0,15.83.163c-.787-.07-1.576-.133-2.366-.151C12.555-.01,11.644,0,10.735.033A21.7,21.7,0,0,0,8.064.312,21.976,21.976,0,0,0,5.7.809a6.412,6.412,0,0,0-3.276,2A6.757,6.757,0,0,0,1.08,5.375,29.156,29.156,0,0,0,.285,8.786a19.168,19.168,0,0,0-.242,2.229c-.011.238-.028.476-.043.713v1.223c.007.048.016.1.02.145.059.682.1,1.367.181,2.046a21.788,21.788,0,0,0,.573,2.878,14.4,14.4,0,0,0,.631,2.006,6.1,6.1,0,0,0,3,3.151,9.683,9.683,0,0,0,2.405.781c.975.2,1.963.3,2.952.4a26.28,26.28,0,0,0,3.5.138c.551-.017,1.1-.061,1.651-.109.574-.05,1.147-.106,1.718-.183a16.707,16.707,0,0,0,3.34-.715,6.166,6.166,0,0,0,2.959-2.11,6.784,6.784,0,0,0,.992-1.976,21.372,21.372,0,0,0,.865-3.414c.115-.724.192-1.455.263-2.185a17.164,17.164,0,0,0,.04-2.507",
    transform: "translate(0 -0.001)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52907-2",
    "data-name": "Path 52907",
    d: "M221.735,22.689h-.25V21.418h-.546V21.2h1.343v.218h-.546Z",
    transform: "translate(-195.348 -18.745)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52908-2",
    "data-name": "Path 52908",
    d: "M237.357,22.689l-.407-.787c-.047-.134-.087-.25-.118-.363.008.131.013.273.013.384v.766h-.236V21.2h.307l.436.858c.055.153.063.171.105.31.052-.158.073-.215.105-.3l.433-.856h.308v1.481h-.236v-.766c0-.121.005-.247.013-.384-.042.142-.074.242-.129.384l-.4.766Z",
    transform: "translate(-209.202 -18.744)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52909-2",
    "data-name": "Path 52909",
    d: "M137.023,44.24h2.558a.07.07,0,0,1,.07.07V58.433a.07.07,0,0,1-.07.07h-2.558a.07.07,0,0,1-.07-.07V44.31a.07.07,0,0,1,.07-.07",
    transform: "translate(-121.09 -39.116)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52910-2",
    "data-name": "Path 52910",
    d: "M54.8,44.24h2.558a.07.07,0,0,1,.07.07V58.433a.07.07,0,0,1-.07.07H54.8a.07.07,0,0,1-.07-.07V44.31a.07.07,0,0,1,.07-.07",
    transform: "translate(-48.391 -39.116)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52911-2",
    "data-name": "Path 52911",
    d: "M62.081,85.481a9.41,9.41,0,0,0-4.643,2.053,8.4,8.4,0,0,0-2.7,6.623.072.072,0,0,0,.071.072h2.558a.07.07,0,0,0,.069-.07A5.849,5.849,0,0,1,59.2,89.578a6.419,6.419,0,0,1,2.881-1.352Z",
    transform: "translate(-48.393 -75.58)",
    fill: "#fff"
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 624.5, 49.03)",
    filter: "url(#Path_52270)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52270-2",
    "data-name": "Path 52270",
    d: "M0,52.976v90.567a42.39,42.39,0,0,0,42.39,42.39H150.85a42.39,42.39,0,0,0,42.39-42.39V42.393A42.391,42.391,0,0,0,146.733.2L38.273,10.787A42.39,42.39,0,0,0,0,52.976",
    transform: "translate(114 111)",
    fill: "url(#linear-gradient)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27310",
    "data-name": "Group 27310",
    transform: "translate(2.119 -6.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142701",
    "data-name": "Path 142701",
    d: "M-68.184,0h18.72V-4.608H-61.632c0-.864.252-1.44,3.96-3.132,5.8-2.628,7.7-5.04,7.7-8.82,0-4.248-3.132-7.452-8.928-7.452-6.3,0-9.144,3.564-9.144,8.568a19.43,19.43,0,0,0,.144,2.376h5.112a15.716,15.716,0,0,1-.108-1.98c0-2.88,1.4-4.32,3.816-4.32a3.041,3.041,0,0,1,3.348,3.312c0,2.16-1.26,3.456-5.832,5.616C-67.608-7.56-68.184-5.724-68.184,0Zm29.916,0H-32.8V-8.5c0-3.348,1.512-5.04,3.636-5.04,1.872,0,2.952,1.26,2.952,3.348V0h5.472V-8.6c0-3.276,1.512-4.932,3.672-4.932,1.872,0,2.952,1.26,2.952,3.348V0H-8.64V-11.448c0-4.176-2.2-6.624-6.084-6.624-3.42,0-5.364,1.764-6.084,4.644h-.036c-.4-2.88-2.592-4.644-6.012-4.644-3.24,0-5.256,1.836-6.084,4.9h-.036l.18-4.608h-5.472ZM-5.94-19.656H-.468v-4.356H-5.94ZM-5.94,0H-.468V-17.784H-5.94ZM2.484,0H7.956V-24.948H2.484Zm8.352,0h5.472V-24.948H10.836ZM19.26-19.656h5.472v-4.356H19.26ZM19.26,0h5.472V-17.784H19.26ZM36.972.288c5.868,0,9.684-3.384,9.684-9.144,0-5.8-3.816-9.216-9.684-9.216s-9.684,3.42-9.684,9.216C27.288-3.1,31.1.288,36.972.288Zm0-4.176c-2.664,0-4.212-1.836-4.212-4.968,0-3.168,1.548-5.04,4.212-5.04s4.212,1.872,4.212,5.04C41.184-5.724,39.636-3.888,36.972-3.888ZM49.068,0H54.54V-8.46c0-3.384,1.728-5.076,4.608-5.076C61.56-13.536,63-12.42,63-9.9V0h5.472V-11.124c0-4.608-2.772-6.948-7.056-6.948-4.032,0-6.12,1.62-7.02,5h-.072l.216-4.716H49.068Z",
    transform: "translate(833 293.135)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142700",
    "data-name": "Path 142700",
    d: "M1.125,0h1.2V-10.4h-1.2Zm3.4-8.355H5.82V-9.87H4.53ZM4.575,0h1.2V-7.41h-1.2ZM7.95,0h1.2V-3.645A2.589,2.589,0,0,1,11.94-6.45c1.59,0,2.31.81,2.31,2.07V0h1.2V-4.635A2.779,2.779,0,0,0,12.345-7.53a3.022,3.022,0,0,0-3.21,2.115H9.12L9.15-7.41H7.95ZM24.18-4.02c0-2.2-1.245-3.51-3.36-3.51-2.22,0-3.645,1.515-3.645,3.885A3.481,3.481,0,0,0,20.85.12C22.8.12,24.1-.9,24.18-2.5H23.07c-.1.975-.96,1.6-2.2,1.6a2.43,2.43,0,0,1-2.49-2.565H24.18Zm-1.11-.315H18.42A2.323,2.323,0,0,1,20.85-6.51a1.971,1.971,0,0,1,2.22,2.085ZM28.95.12C31.2.12,32.4-.75,32.4-2.2a1.6,1.6,0,0,0-.735-1.41,5.6,5.6,0,0,0-2.235-.51,9.657,9.657,0,0,1-2.07-.345.791.791,0,0,1-.48-.84c0-.735.825-1.2,2.1-1.2,1.32,0,1.98.51,2,1.62h1.11c0-1.665-.93-2.64-3.15-2.64-1.98,0-3.255.9-3.255,2.295a1.714,1.714,0,0,0,.615,1.38,4.947,4.947,0,0,0,2.4.585,8.142,8.142,0,0,1,2.04.345.766.766,0,0,1,.465.765c0,.795-.735,1.26-2.265,1.26S26.79-1.485,26.79-2.475H25.68C25.68-1.05,26.46.12,28.95.12ZM41.1.12a3.529,3.529,0,0,0,3.75-3.81A3.545,3.545,0,0,0,41.1-7.53a3.545,3.545,0,0,0-3.75,3.84A3.529,3.529,0,0,0,41.1.12Zm0-1.08a2.469,2.469,0,0,1-2.55-2.73A2.486,2.486,0,0,1,41.1-6.45a2.486,2.486,0,0,1,2.55,2.76A2.469,2.469,0,0,1,41.1-.96ZM46.845,0h1.2V-6.36h2.76V-7.41h-2.76v-.735a1.34,1.34,0,0,1,1.485-1.47,3.569,3.569,0,0,1,1.155.18V-10.5a4.266,4.266,0,0,0-1.305-.195,2.345,2.345,0,0,0-2.535,2.55v.735H45.6v1.05h1.245Zm12.18.12C61.08.12,62.4-1.08,62.4-2.94H61.29A1.99,1.99,0,0,1,59.055-.96c-1.44,0-2.37-1.065-2.37-2.745A2.437,2.437,0,0,1,59.13-6.45a1.947,1.947,0,0,1,2.13,2.01h1.11a2.968,2.968,0,0,0-3.255-3.09A3.481,3.481,0,0,0,55.485-3.7C55.485-1.365,56.865.12,59.025.12Zm8.7,0a3.529,3.529,0,0,0,3.75-3.81,3.545,3.545,0,0,0-3.75-3.84,3.545,3.545,0,0,0-3.75,3.84A3.529,3.529,0,0,0,67.725.12Zm0-1.08a2.469,2.469,0,0,1-2.55-2.73,2.486,2.486,0,0,1,2.55-2.76,2.486,2.486,0,0,1,2.55,2.76A2.469,2.469,0,0,1,67.725-.96ZM76.5.12a2.693,2.693,0,0,0,2.925-2.1h.03c-.015.66-.03,1.32-.075,1.98h1.2V-10.4h-1.2v4.47h-.015c-.27-.975-1.215-1.6-2.76-1.6a3.5,3.5,0,0,0-3.63,3.78C72.975-1.44,74.355.12,76.5.12Zm.195-1.08a2.52,2.52,0,0,1-2.52-2.79,2.5,2.5,0,0,1,2.535-2.7,2.4,2.4,0,0,1,2.67,2.46v.375A2.5,2.5,0,0,1,76.695-.96ZM89.46-4.02c0-2.2-1.245-3.51-3.36-3.51-2.22,0-3.645,1.515-3.645,3.885A3.481,3.481,0,0,0,86.13.12C88.08.12,89.385-.9,89.46-2.5H88.35c-.1.975-.96,1.6-2.2,1.6a2.431,2.431,0,0,1-2.49-2.565H89.46Zm-1.11-.315H83.7A2.323,2.323,0,0,1,86.13-6.51a1.971,1.971,0,0,1,2.22,2.085Z",
    transform: "translate(788 313.408)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27247",
    "data-name": "Group 27247",
    transform: "translate(804 213.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39793",
    "data-name": "Path 39793",
    d: "M27.695,13.033A142.472,142.472,0,0,0,12.675.29a2.031,2.031,0,0,0-2.761.724A34.447,34.447,0,0,1,8.033,4.109C7.7,4.594,7.354,5.069,7,5.539c.215-.284-.042.052-.084.1q-.144.182-.291.362-.294.36-.6.712a34.019,34.019,0,0,1-2.439,2.55Q2.911,9.9,2.2,10.5q-.319.269-.646.531c-.121.1-.242.193-.364.288.273-.212-.114.083-.183.135a2.07,2.07,0,0,0-.724,2.761,2.039,2.039,0,0,0,2.761.724A36.609,36.609,0,0,0,13.4,3.051l-2.76.724q.965.712,1.919,1.44l.414.317c-.242-.187.207.161.251.2q.494.385.984.774,1.838,1.46,3.625,2.983,3.615,3.078,7.009,6.4a2.018,2.018,0,0,0,2.854-2.854",
    transform: "translate(0 28.688) rotate(-81)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39794",
    "data-name": "Path 39794",
    d: "M27.695,13.033A142.472,142.472,0,0,0,12.675.29a2.031,2.031,0,0,0-2.761.724A34.447,34.447,0,0,1,8.033,4.109C7.7,4.594,7.354,5.069,7,5.539c.215-.284-.042.052-.084.1q-.144.182-.291.362-.294.36-.6.712a34.019,34.019,0,0,1-2.439,2.55Q2.911,9.9,2.2,10.5q-.319.269-.646.531c-.121.1-.242.193-.364.288.273-.212-.114.083-.183.135a2.07,2.07,0,0,0-.724,2.761,2.039,2.039,0,0,0,2.761.724A36.609,36.609,0,0,0,13.4,3.051l-2.76.724q.965.712,1.919,1.44l.414.317c-.242-.187.207.161.251.2q.494.385.984.774,1.838,1.46,3.625,2.983,3.615,3.078,7.009,6.4a2.018,2.018,0,0,0,2.854-2.854",
    transform: "translate(59.234 6.868) rotate(99)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25808",
    "data-name": "Group 25808",
    transform: "translate(23.574 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39795",
    "data-name": "Path 39795",
    d: "M1379.958,1042.6l-7.655,27.739c-.756,2.74,3.5,3.909,4.252,1.173l7.655-27.739c.756-2.74-3.5-3.909-4.252-1.173Z",
    transform: "translate(-1372.213 -1041.037)",
    fill: "#e4e4e4"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloper);
export default __webpack_public_path__ + "static/media/Developer.1f8f66e9bf55842a1b267d7ff9086a95.svg";
export { ForwardRef as ReactComponent };